<template>
  <div class="showTemplate">
    <a-statistic-countdown
      :title="deadtitle"
      :value="deadline"
      style="margin-left: 50px; position: absolute; right: 130px; top: 10px"
      @finish="onFinish"
      v-if="timer_status"
    />

    <a-switch
      checked-children="刷新开启"
      un-checked-children="刷新关闭"
      :checked="timer_status"
      @change="changeTimerStatus"
      style="margin-left: 50px; position: absolute; right: 30px; top: 30px"
    />

    <div class="salesCard">
      <a-tabs
        default-active-key="1"
        :tabBarStyle="{
          display: 'flex',
          justifyContent: 'flex-start',
          position: 'relative',
        }"
      >
        <a-tab-pane tab="数据概览" key="1"> </a-tab-pane>
        <div class="extra-wrapper" slot="tabBarExtraContent">
          <div class="extra-item">
            <a @click="setTimeDay(0)" :class="timeday == '0' ? 'selected' : ''"
              >今日</a
            >
            <a
              @click="setTimeDay(-1)"
              :class="timeday == '-1' ? 'selected' : ''"
              >昨日</a
            >
            <a
              @click="setTimeDay(-3)"
              :class="timeday == '-3' ? 'selected' : ''"
              >近3天</a
            >
            <a
              @click="setTimeDay(-7)"
              :class="timeday == '-7' ? 'selected' : ''"
              >近7天</a
            >
            <a @click="setTimeDay(1)" :class="timeday == '1' ? 'selected' : ''"
              >本月</a
            >
            <a @click="setTimeDay(2)" :class="timeday == '2' ? 'selected' : ''"
              >上月</a
            >
          </div>
          <a-range-picker
            :ranges="{
              今日: [moment(), moment()],
              昨日: [
                moment().subtract(1, 'days'),
                moment().subtract(1, 'days'),
              ],
              本周: [moment().startOf('week'), moment()],
              上周: [
                moment().subtract(1, 'week').startOf('week'),
                moment().subtract(1, 'week').endOf('week'),
              ],
              本月: [moment().startOf('month'), moment()],
              上月: [
                moment().subtract(1, 'month').startOf('month'),
                moment().subtract(1, 'month').endOf('month'),
              ],
            }"
            :value="range_date"
            @change="onTimeChange"
            class="filterItem"
            showToday
            :placeholder="['开始时间', '结束时间']"
          />
        </div>
      </a-tabs>
      <a-spin :spinning="toploading" tip="加载中...">
        <a-row :gutter="24">
          <a-col :sm="24" :md="12" :xl="4" :style="{ marginBottom: '10px' }">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>消耗（元）</span>
                        <span class="acss-18kfphl">
                          <a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span>¥ {{ report.stat_cost || '0.00' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p"
                        >￥{{ report.month_stat_cost }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :sm="24" :md="12" :xl="4" :bordered="false">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>整体支付ROI</span>
                        <span class="acss-18kfphl"
                          ><a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span>{{
                          report.total_prepay_and_pay_order_roi2 || '0'
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p">{{
                        report.month_total_prepay_and_pay_order_roi2 || '-'
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :sm="24" :md="12" :xl="4" :bordered="false">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>整体成交金额</span>
                        <span class="acss-18kfphl"
                          ><a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span
                          >¥
                          {{
                            report.total_pay_order_gmv_for_roi2 || '0.00'
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p"
                        >￥{{ report.month_total_pay_order_gmv_for_roi2 }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :sm="24" :md="12" :xl="4" :bordered="false">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>整体成交订单数</span>
                        <span class="acss-18kfphl"
                          ><a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span>{{
                          report.total_pay_order_count_for_roi2 || '0'
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p">{{
                        report.month_total_pay_order_count_for_roi2
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :sm="24" :md="12" :xl="4" :bordered="false">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>整体成交订单成本</span>
                        <span class="acss-18kfphl"
                          ><a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span>{{
                          report.total_cost_per_pay_order_for_roi2 || '0'
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p">{{
                        report.month_total_cost_per_pay_order_for_roi2
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :sm="24" :md="12" :xl="4" :bordered="false">
            <div class="ant-card">
              <div class="ant-card-body" style="padding: 20px 24px 8px">
                <div class="acss-79elbk">
                  <div class="acss-14lc1cu">
                    <div class="acss-qdes8r"></div>
                    <div class="acss-1odwksc">
                      <div class="acss-1qoci3j">
                        <span>整体成交智能优惠券金额</span>
                        <span class="acss-18kfphl"
                          ><a-icon type="question-circle" />
                        </span>
                      </div>
                      <div class="text-2xl font-bold">
                        <span
                          >¥
                          {{
                            report.total_pay_order_coupon_amount_for_roi2 ||
                            '0.00'
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="acss-1fpsglh">
                    <div class="acss-eji7bv">
                      <span class="acss-1x0bxe0">本月</span>
                      <span class="acss-72p16p"
                        >￥{{
                          report.month_total_pay_order_coupon_amount_for_roi2
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-spin>
    </div>

    <div class="tableWapper">
      <a-tabs
        default-active-key="1"
        :tabBarStyle="{ display: 'flex', justifyContent: 'flex-start' }"
      >
        <a-tab-pane key="1" tab="全部计划"></a-tab-pane>
      </a-tabs>
      <div></div>

      <div v-if="tableKey == '1' || tableKey == '4'">
        <Action
          ref="action"
          v-if="
            selectedRowKeys.length > 0 && !suggestOrderDrawer && !allOrderDrawer
          "
          :selectedRowKeys="selectedRowKeys"
          :smart_bid_type="smart_bid_type"
          :advertiser_id="advertiser_id"
          :dataMap="dataMap"
          @clearSelect="clearSelect"
        ></Action>
        <div class="filterCondition" style="padding: 0px 5px;display: flex; justify-content: space-between;">
          <a-space>
            <a-radio-group
              default-value="SMART_BID_CUSTOM"
              v-model="smart_bid_type"
              button-style="solid"
              @change="handletargetChange"
            >
              <a-radio-button value="SMART_BID_CONSERVATIVE">
                放量投放
              </a-radio-button>
              <a-radio-button value="SMART_BID_CUSTOM">
                控成本投放
              </a-radio-button>
            </a-radio-group>

            <a-input-search
              v-model="order_id"
              :allowClear="true"
              style="width: 320px; margin-left: 0px"
              placeholder="计划ID/名称/商品ID/名称"
              enter-button
              @search="onSearchKey"
            >
              <a-select
                slot="addonBefore"
                @change="changeTypeAction"
                :default-value="search_keyword_type"
                style="width: 80px"
              >
                <a-select-option value="AD"> 计划 </a-select-option>
                <a-select-option value="AWEME"> 抖音号 </a-select-option>
                <a-select-option value="PRODUCT"> 商品 </a-select-option>
              </a-select>
            </a-input-search>

            <a-select
              v-model="status"
              style="width: 140px"
              @change="handleChange"
              placeholder="全部计划状态"
            >
              <a-select-option
                v-for="(item, index) in statusData"
                :key="index"
                :value="item.value"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>

            <a-select
              v-model="having_cost"
              style="width: 80px"
              @change="handleCostChange"
            >
              <a-select-option value="ALL"> 全部 </a-select-option>
              <a-select-option value="YES"> 有消耗 </a-select-option>
              <a-select-option value="NO"> 无消耗 </a-select-option>
            </a-select>
            <a-range-picker
              :ranges="{
                今日: [moment(), moment()],
                昨日: [
                  moment().subtract(1, 'days'),
                  moment().subtract(1, 'days'),
                ],
                本周: [moment().startOf('week'), moment()],
                上周: [
                  moment().subtract(1, 'week').startOf('week'),
                  moment().subtract(1, 'week').endOf('week'),
                ],
                本月: [moment().startOf('month'), moment()],
                上月: [
                  moment().subtract(1, 'month').startOf('month'),
                  moment().subtract(1, 'month').endOf('month'),
                ],
              }"
              :value="range_create_date"
              @change="onTimeCreateChange"
              class="filterItem"
              showToday
              :placeholder="['开始时间', '结束时间']"
              style="margin-left: 0px; width: 220px"
            />
          </a-space>

          <a-space>
            <!-- <a-button
              type="primary"
              icon="swap"
              @click="
                alldata = [];
                showCheckOrder('suggest');
              "
              >审核建议计划</a-button
            > -->
            <a-button
              type="primary"
              icon="swap"
              @click="
                alldata = [];
                showCheckOrder('bq');
              "
              >标签计划</a-button
            >
            <a-button
              type="primary"
              icon="swap"
              @click="
                alldata = [];
                allOrderDrawer = true;
              "
              >多账户计划对比</a-button
            >
            <a-button
              type="default"
              icon="setting"
              @click="showColumnConfigModal"
              title="自定义列"
            >
              自定义列
            </a-button>
          </a-space>
        </div>
        <a-spin :spinning="spinning" tip="加载中...">
          <div
            class="scroll-tabox"
            style="position: relative; padding-bottom: 50px"
          >
            <a-table
              ref="inOrderTable"
              :columns="columns"
              :data-source="data"
              :pagination="pagination"
              :sortDirections="['descend', 'ascend', '']"
              @change="handleTableChange"
              :rowKey="(record) => record.ad_info.id"
              :rowSelection="{
                selectedRowKeys,
                onChange: onSelectChange,
              }"
              :scroll="{ x: 2000 }"
            >
              <div slot="ad" class="aweme-right" slot-scope="text">
                <div>
                  <a-tooltip placement="top" :title="text.ad_info.name">
                    <div class="aweme-title" @click="getDetail(text)">
                      <a-badge
                        count="手动创建"
                        :number-style="{ backgroundColor: '#52c41a' }"
                        v-if="text.is_sd > 0"
                      />
                      <a-badge
                        count="托管创建"
                        :number-style="{ backgroundColor: '#eb2f96' }"
                        v-if="text.is_auto > 0"
                      />

                      {{ text.ad_info.name }}
                    </div>
                  </a-tooltip>
                </div>

                <div style="display: flex">
                  <div>
                    <a-switch
                      size="small"
                      :checked="
                        text.ad_info.opt_status == 'ENABLE' ? true : false
                      "
                      :loading="switchloading"
                      @change="onSwitchChange(text)"
                    />
                  </div>
                  <div style="margin-left: 5px">
                    <div>
                      <a-popover
                        title="设置备注"
                        placement="bottom"
                        trigger="click"
                        :getPopupContainer="
                          (triggerNode) => {
                            return triggerNode.parentNode || document.body;
                          }
                        "
                      >
                        <template slot="content">
                          <p>
                            <a-textarea
                              placeholder="设置备注"
                              v-model="remark"
                              style="width: 100%"
                            />
                          </p>
                          <p>
                            <a-button
                              type="primary"
                              icon="edit"
                              style="width: 100%; margin-top: 5px"
                              @click="setAdRemark(text)"
                              >设置备注</a-button
                            >
                          </p>
                        </template>
                        <span v-if="text.remark == ''"
                          >备注 <a-icon type="edit" style="cursor: pointer"
                        /></span>
                        <span
                          v-else
                          :title="text.remark"
                          class="remark"
                          @click="remark = text.remark"
                          >{{ text.remark }}
                          <a-icon type="edit" style="cursor: pointer"
                        /></span>
                      </a-popover>
                    </div>
                    <div class="small">
                      创建时间:{{ text.ad_info.create_time }}
                    </div>
                    <div class="small">
                      ID:{{ text.ad_info.id }}
                      <a-icon type="copy" @click="text_copy(text.ad_info.id)" />
                    </div>

                    <div class="small" v-if="text.monitor_info">
                      <div>
                        <div v-if="text.is_white">
                          <span style="color: #333">
                            <a-icon type="wifi" /> 未监控</span
                          >
                          <a-tooltip
                            placement="topLeft"
                            title="取消加白计划，计划将会重新被监控"
                          >
                            <span
                              style="
                                color: #597ef7;
                                cursor: pointer;
                                margin-left: 10px;
                              "
                              @click="addwhite(text, 'del')"
                            >
                              取消加白</span
                            >
                          </a-tooltip>
                        </div>
                        <div v-else>
                          <span style="color: green"
                            ><a-icon type="wifi" /> 监控中</span
                          >
                          <span
                            style="
                              color: #597ef7;
                              cursor: pointer;
                              margin-left: 10px;
                            "
                            @click="setmonitor(text)"
                            >监控计划</span
                          >
                          <span
                            style="
                              color: #597ef7;
                              cursor: pointer;
                              margin-left: 10px;
                            "
                            @click="setScmonitor(text)"
                            >监控素材</span
                          >
                          <a-tooltip
                            placement="topLeft"
                            title="加入计划白名单后，该计划将不会被监控"
                          >
                            <span
                              style="
                                color: #597ef7;
                                cursor: pointer;
                                margin-left: 10px;
                                margin-right: 10px;
                              "
                              @click="addwhite(text, 'add')"
                            >
                              加白</span
                            >
                          </a-tooltip>
                          <span
                            style="color: #fa8c16; cursor: pointer"
                            v-if="text.is_monitor > 0"
                            @click="getMonitorlog(text)"
                          >
                            监控记录
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="small" v-else>
                      <div>
                        <span><a-icon type="wifi" /> 计划未配置</span>
                        <span
                          style="
                            color: #597ef7;
                            cursor: pointer;
                            margin-left: 10px;
                          "
                          @click="setmonitor(text)"
                          >监控计划</span
                        >
                        <span
                          style="
                            color: #597ef7;
                            cursor: pointer;
                            margin-left: 10px;
                          "
                          @click="setScmonitor(text)"
                          >监控素材</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="delivery_setting"
                slot="delivery_setting"
                slot-scope="text"
              >
                <div v-if="text.ad_info.budget">
                  预算:<b style="color: #000;">{{ text.ad_info.budget }}</b>元
                  <span v-if="text.ad_info.budget_mode == 'BUDGET_MODE_DAY'"
                    >/日</span
                  >
                  <span v-if="text.ad_info.budget_mode == 'BUDGET_MODE_TOTAL'"
                    >/总</span
                  >

                  <a-popover
                    title="设置预算"
                    placement="bottom"
                    trigger="click"
                    v-model="popoverVisibleMap[`${text.ad_info.id}_2`]"
                    :getPopupContainer="
                      (triggerNode) => {
                        return triggerNode.parentNode || document.body;
                      }
                    "
                  >
                    <template slot="content">
                      <p>
                        <a-input
                          placeholder="预算需要在300~9999999.99之间"
                          v-model="new_budget"
                        />
                      </p>
                      <p>
                        <a-button
                          type="primary"
                          style="width: 100%; margin-top: 10px"
                          @click="editOne(text, new_budget, 2)"
                          :loading="btnloadiong"
                          >确定</a-button
                        >
                      </p>
                    </template>
                    <a-icon
                      type="edit"
                      @click="new_budget = text.ad_info.budget"
                    />
                  </a-popover>
                </div>
                <div v-if="text.ad_info.roi2_goal">
                  ROI目标:<b style="color: #000;">{{ text.ad_info.roi2_goal }}</b>

                  <b v-if="text.ad_info.deep_external_action == 'AD_CONVERT_TYPE_LIVE_PAY_ROI'">(支付)</b>
                  <b v-else style="color: green;">(净成交)</b> 

                  <a-popover
                    title="设置ROI目标"
                    placement="bottom"
                    trigger="click"
                    v-model="popoverVisibleMap[`${text.ad_info.id}_3`]"
                    :getPopupContainer="
                      (triggerNode) => {
                        return triggerNode.parentNode || document.body;
                      }
                    "
                  >
                    <template slot="content">
                      <p><a-input placeholder="ROI目标" v-model="new_roi" /></p>
                      <p>
                        <a-button
                          type="primary"
                          style="width: 100%; margin-top: 10px"
                          @click="editOne(text, new_roi, 3)"
                          :loading="btnloadiong"
                          >确定</a-button
                        >
                      </p>
                    </template>
                    <a-icon
                      type="edit"
                      @click="new_roi = text.ad_info.roi2_goal"
                    />
                  </a-popover>
                </div>

                <div>
                  <a-progress
                    :percent="
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      )
                    "
                    size="small"
                    status="active"
                    v-if="
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      ) < 70
                    "
                  />
                  <a-progress
                    strokeColor="#f5222d"
                    :percent="
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      )
                    "
                    size="small"
                    status="active"
                    v-else-if="
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      ) < 100 &&
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      ) >= 70
                    "
                  />
                  <a-progress
                    :percent="
                      parseInt(
                        (text.stats_info.stat_cost / text.ad_info.budget) * 100
                      )
                    "
                    size="small"
                    v-else
                  />
                </div>
              </div>

              <div slot="aweme" slot-scope="text">
                <div
                  class="aweme-id"
                  v-if="text?.room_info?.[0]?.anchor_avatar"
                >
                  <div class="aweme-id-left">
                    <img
                      :src="text?.room_info?.[0]?.anchor_avatar"
                      style="border-radius: 50%"
                    />
                  </div>
                  <div class="aweme-id-right">
                    <h6 style="width: 100%;">{{ text.room_info?.[0].anchor_name }}
                      <a-popover
                          title="设置商品分成"
                          placement="bottom"
                          trigger="click"
                          :getPopupContainer="
                            (triggerNode) => {
                              return triggerNode.parentNode || document.body;
                            }
                          "
                        >
                          <template slot="content">
                            <p>
                              <a-input-number
                                placeholder="商品分成"
                                style="width: 100%"
                                min="0"
                                max="100"
                                v-model="divide_into_rate"
                              />
                            </p>
                            <p>
                              <a-button
                                type="primary"
                                style="width: 100%; margin-top: 10px"
                                @click="
                                  set_divide_into_rate(
                                    text.advertiser_id,
                                    text?.room_info?.[0]?.anchor_id,
                                    divide_into_rate
                                  )
                                "
                                :loading="btnloadiong"
                                >确定</a-button
                              >
                            </p>
                          </template>
                          <b style="font-size: 12px; color: green"
                            >【分成:{{ text.divide_into_rate||100 }}%】</b
                          >
                        </a-popover>

                    </h6>
                    <p>
                      抖音ID:{{ text?.room_info?.[0]?.anchor_id }}
                      <a-icon
                        type="copy"
                        @click="text_copy(text?.room_info?.[0].anchor_id)"
                      />
                    </p>
                  </div>
                </div>

                <div v-for="(it, i) in getDisplayProducts(text.product_info, text.ad_id)" :key="i">
                  <div class="aweme-id">
                    <div class="aweme-id-left">
                      <img
                        :src="it.product_image"
                        style="border-radius: 3px"
                        @click="goDetail(it.product_id)"
                      />
                    </div>
                    <div class="aweme-id-right">
                      <div style="display: flex">
                        <h6>{{ it.product_name }}</h6>
                        <a-popover
                          title="设置商品佣金率"
                          placement="bottom"
                          trigger="click"
                          :getPopupContainer="
                            (triggerNode) => {
                              return triggerNode.parentNode || document.body;
                            }
                          "
                        >
                          <template slot="content">
                            <p>
                              <a-input-number
                                placeholder="商品佣金率"
                                style="width: 100%"
                                min="0"
                                max="100"
                                v-model="commission_rate"
                              />
                            </p>
                            <p>
                              <a-button
                                type="primary"
                                style="width: 100%; margin-top: 10px"
                                @click="
                                  set_commission_rate(
                                    text.advertiser_id,
                                    text?.room_info?.[0]?.anchor_id,
                                    it.product_id,
                                    commission_rate
                                  )
                                "
                                :loading="btnloadiong"
                                >确定</a-button
                              >
                            </p>
                          </template>
                          <b style="font-size: 12px; color: green"
                            >【{{ it.commission_rate }}%】</b
                          >
                        </a-popover>
                      </div>
                      <p>
                        ID:{{ it.product_id }}
                        <a-icon
                          type="copy"
                          @click="text_copy(it.product_id)"
                          style="margin-left: 10px; margin-right: 10px"
                        />
                        <a-icon
                          type="swap"
                          @click="
                            all_order_id = it.product_id;
                            alldata = [];
                            succ = 0;
                            allOrderDrawer = true;
                          "
                        />
                      </p>
                    </div>
                  </div>
                  <div class="statistic-wrapper" style="background: none;border: 1px solid #e6f7ff;display: none;">
                    <div class="statistic-item" style="margin-bottom: 0px">
                      <p class="label">全部销售额</p>
                      <p class="value">{{ it.total_pay_amount_str }}</p>
                    </div>
                    <div class="statistic-item" style="margin-bottom: 0px">
                      <p class="label">有效销售额</p>
                      <p class="value">{{ it.valid_total_pay_amount_str }}</p>
                    </div>
                    <div class="statistic-item" style="margin-bottom: 0px">
                      <p class="label">退款销售额</p>
                      <p class="value">{{ it.refund_total_pay_amount_str }}</p>
                    </div>
                    <div class="statistic-item" style="margin-top: 0px">
                      <p class="label">全部佣金</p>
                      <p class="value">
                        {{ it.estimated_total_commission_str }}
                      </p>
                    </div>
                    <div class="statistic-item" style="margin-top: 0px">
                      <p class="label">有效佣金</p>
                      <p class="value">
                        {{ it.valid_estimated_total_commission_str }}
                      </p>
                    </div>
                    <div class="statistic-item" style="margin-top: 0px">
                      <p class="label">退货率</p>
                      <p class="value">{{ it.refund_rate }}%</p>
                    </div>
                  </div>
                </div>
                
                <!-- 展开更多按钮 -->
                <div v-if="text.product_info && text.product_info.length > 1" style="text-align: left;">
                  <a-button 
                    type="link" 
                    size="small"
                    @click="openProductDrawer(text.product_info, text.ad_id, text.ad_info.name)"
                  >
                    <a-icon type="right" />
                    展开更多 ({{ text.product_info.length - 1 }})
                  </a-button>
                </div>
              </div>

              <template slot="zt" slot-scope="text">
                
                <a-tooltip
                    placement="top"
                    title="成本保障生效中"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'IN_EFFECT'"
                  >
                    <a-tag color="cyan"> 保 </a-tag>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="成本保障已失效"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'INVALID'"
                  >
                    <a-tag color="pink"> 保 </a-tag>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="成本保障确认中"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'CONFIRMING'"
                  >
                    <a-tag color="orange"> 保 </a-tag>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="成本保障已到账"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'PAID'"
                  >
                    <a-tag color="blue"> 保 </a-tag>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="成本保障已结束"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'ENDED'"
                  >
                    <a-tag color="purple"> 保 </a-tag>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="无成本保障状态"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'DEFAULT'"
                  >
                    <a-tag color="#f50"> 保 </a-tag>
                  </a-tooltip>

                  <a-tag color="green" v-if="text.ad_info.status == 'DELIVERY_OK'"> 投放中 </a-tag> 
                  <a-tag color="red" v-else>
                    {{ getStatusName(text.ad_info.status) }}
                  </a-tag>
              </template>


              <template slot="order_cencus" slot-scope="text">
                
                <div class="statistic-wrapper" style="background: none; padding: 0px;">
                    <div class="statistic-item" style="margin-bottom: 10px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">全部销售额</p>
                      <p class="value">{{ text.stats_info.all_total_pay_amount_str }}</p>
                    </div>
                    <div class="statistic-item" style="margin-bottom: 10px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">有效销售额</p>
                      <p class="value">{{ text.stats_info.all_valid_total_pay_amount_str }}</p>
                    </div>
                    <div class="statistic-item" style="margin-bottom: 10px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">退款销售额</p>
                      <p class="value">{{ text.stats_info.all_refund_total_pay_amount_str }}</p>
                    </div>
                    <div class="statistic-item" style="margin-top: 0px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">全部佣金</p>
                      <p class="value">
                        {{ text.stats_info.all_estimated_total_commission_str }}
                      </p>
                    </div>
                    <div class="statistic-item" style="margin-top: 0px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">有效佣金</p>
                      <p class="value">
                        {{ text.stats_info.all_valid_estimated_total_commission_str }}
                      </p>
                    </div>
                    <div class="statistic-item" style="margin-top: 0px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">退货率</p>
                      <p class="value">{{ text.stats_info.all_refund_rate }}%</p>
                    </div>
                  </div>
              </template>




              <div
                class="green-roi"
                slot="total_prepay_and_pay_order_roi2"
                slot-scope="text"
              >
                <b
                  v-if="text.stats_info.total_prepay_and_pay_order_roi2 > 0"
                  style="color: green"
                  >{{ text.stats_info.total_prepay_and_pay_order_roi2 }}</b
                >
                <b v-else style="color: red">0</b>
              </div>

              <div slot="stat_cost" slot-scope="text">
                {{ text.stats_info.stat_cost }}
              </div>

              <div slot="total_pay_order_gmv_for_roi2" slot-scope="text">
                {{ text.stats_info.total_pay_order_gmv_for_roi2 }}
              </div>

              <div slot="total_pay_order_count_for_roi2" slot-scope="text">
                {{ text.stats_info.total_pay_order_count_for_roi2 }}
              </div>

              <div slot="total_cost_per_pay_order_for_roi2" slot-scope="text">
                {{ text.stats_info.total_cost_per_pay_order_for_roi2 }}
              </div>

              <div
                slot="total_pay_order_coupon_amount_for_roi2"
                slot-scope="text"
              >
                {{ text.stats_info.total_pay_order_coupon_amount_for_roi2 }}
              </div>

              <div
                slot="total_pay_order_gmv_include_coupon_for_roi2"
                slot-scope="text"
              >
                {{ formatAmount(text.stats_info?.total_pay_order_gmv_include_coupon_for_roi2) }}
              </div>

              <div
                slot="total_ecom_platform_subsidy_amount_for_roi2"
                slot-scope="text"
              >
                {{ formatAmount(text.stats_info?.total_ecom_platform_subsidy_amount_for_roi2) }}
              </div>

              <div
                slot="total_prepay_and_pay_settle_roi2_1h"
                slot-scope="text"
              >
                <b
                  v-if="(text.stats_info?.total_prepay_and_pay_settle_roi2_1h || 0) > 0"
                  style="color: green"
                >
                  {{ formatNumber(text.stats_info?.total_prepay_and_pay_settle_roi2_1h) }}
                </b>
                <b v-else style="color: red">
                  {{ formatNumber(text.stats_info?.total_prepay_and_pay_settle_roi2_1h) }}
                </b>
              </div>

              <div
                slot="total_order_settle_amount_for_roi2_1h"
                slot-scope="text"
              >
                {{ formatAmount(text.stats_info?.total_order_settle_amount_for_roi2_1h) }}
              </div>

              <div
                slot="total_order_settle_count_for_roi2_1h"
                slot-scope="text"
              >
                {{ text.stats_info?.total_order_settle_count_for_roi2_1h || 0 }}
              </div>

              <div
                slot="total_cost_per_pay_order_settle_for_roi2_1h"
                slot-scope="text"
              >
                {{ formatAmount(text.stats_info?.total_cost_per_pay_order_settle_for_roi2_1h) }}
              </div>

              <div
                slot="total_order_real_settle_amount_for_roi2_1h"
                slot-scope="text"
              >
                {{ formatAmount(text.stats_info?.total_order_real_settle_amount_for_roi2_1h) }}
              </div>

              <div
                slot="no_refund_ecom_coupon_amount_for_roi2"
                slot-scope="text"
              >
                {{ formatAmount(text.stats_info?.no_refund_ecom_coupon_amount_for_roi2) }}
              </div>

              <div
                slot="no_refund_ecom_platform_subsidy_amount_for_roi2"
                slot-scope="text"
              >
                {{ formatAmount(text.stats_info?.no_refund_ecom_platform_subsidy_amount_for_roi2) }}
              </div>

              <div
                slot="total_order_settle_count_rate_for_roi2_1h"
                slot-scope="text"
              >
                {{ formatPercent(text.stats_info?.total_order_settle_count_rate_for_roi2_1h) }}
              </div>

              <div
                slot="total_order_settle_amount_rate_for_roi2_1h"
                slot-scope="text"
              >
                {{ formatPercent(text.stats_info?.total_order_settle_amount_rate_for_roi2_1h) }}
              </div>

              <div
                slot="total_refund_order_count_for_roi2_1h"
                slot-scope="text"
              >
                <b style="color: red">
                  {{ text.stats_info?.total_refund_order_count_for_roi2_1h || 0 }}
                </b>
              </div>

              <div
                slot="total_refund_order_gmv_for_roi2_1h_all"
                slot-scope="text"
              >
                <b style="color: red">
                  {{ formatAmount(text.stats_info?.total_refund_order_gmv_for_roi2_1h_all) }}
                </b>
              </div>

              <div
                slot="total_refund_order_gmv_for_roi2_1h_rate"
                slot-scope="text"
              >
                <b style="color: red">
                  {{ formatPercent(text.stats_info?.total_refund_order_gmv_for_roi2_1h_rate) }}
                </b>
              </div>

              <div
                slot="total_unfinished_estimate_order_gmv_for_roi2"
                slot-scope="text"
              >
                {{
                  text.stats_info.total_unfinished_estimate_order_gmv_for_roi2
                }}
              </div>

              <div slot="all_total_pay_amount_str" slot-scope="text">
                {{ text.stats_info.all_total_pay_amount_str }}
              </div>
              <div slot="all_total_count" slot-scope="text">
                {{ text.stats_info.all_total_count }}
              </div>
              <div slot="all_estimated_total_commission_str" slot-scope="text">
                {{ text.stats_info.all_estimated_total_commission_str }}
              </div>

              <div slot="all_valid_total_pay_amount_str" slot-scope="text">
                {{ text.stats_info.all_valid_total_pay_amount_str }}
              </div>
              <div slot="all_valid_count" slot-scope="text">
                {{ text.stats_info.all_valid_count }}
              </div>
              <div
                slot="all_valid_estimated_total_commission_str"
                slot-scope="text"
              >
                {{ text.stats_info.all_valid_estimated_total_commission_str }}
              </div>

              <!-- <div slot="all_valid_total_pay_amount_str" slot-scope="text">
                <b style="color: green">{{
                  text.stats_info.all_valid_total_pay_amount_str
                }}</b>
              </div>
              <div slot="all_valid_count" slot-scope="text">
                <b style="color: green">{{
                  text.stats_info.all_valid_count
                }}</b>
              </div>
              <div
                slot="all_valid_estimated_total_commission_str"
                slot-scope="text"
              >
                <b style="color: green">{{
                  text.stats_info.all_valid_estimated_total_commission_str
                }}</b>
              </div> -->

              <div slot="all_refund_total_pay_amount_str" slot-scope="text">
                <b style="color: red">{{
                  text.stats_info.all_refund_total_pay_amount_str
                }}</b>
              </div>
              <div slot="all_refund_count" slot-scope="text">
                <b style="color: red">{{ text.stats_info.all_refund_count }}</b>
              </div>
              <div
                slot="all_refund_estimated_total_commission_str"
                slot-scope="text"
              >
                <b style="color: red">{{
                  text.stats_info.all_refund_estimated_total_commission_str
                }}</b>
              </div>

              <div slot="all_refund_rate" slot-scope="text">
                <b style="color: red"
                  >{{ text.stats_info.all_refund_rate }} %</b
                >
              </div>

              <div slot="all_profit" slot-scope="text">
                <b style="color: red" v-if="text.stats_info.all_profit < 0"
                  >{{ text.stats_info.all_profit }} 元</b
                >
                <b style="color: green" v-else
                  >{{ text.stats_info.all_profit }} 元</b
                >
              </div>

              <div slot="all_profit_rate" slot-scope="text" v-if="!text.error">
                <b style="color: green"
                  >{{ text.stats_info.all_profit_rate }} %</b
                >
              </div>

              <div
                style="cursor: pointer"
                slot="action"
                slot-scope="text, record"
              >
                <div class="rowOperate">
                  <span
                    slot="action"
                    class="actionItem"
                    @click="getDetail(record)"
                    >详情</span
                  >
                  <span
                    slot="action"
                    class="actionItem"
                    @click="deleteAd(record)"
                    style="color: red"
                    >删除</span
                  >
                </div>
              </div>
            </a-table>
          </div>
        </a-spin>
      </div>
    </div>

    <Detail :advertiser_id="post_advertiser_id" ref="detail" @closeOrderDrawer="closeOrderDrawer"></Detail>

    <WarnRuleModal
      v-if="showRuleModal"
      :visible="showRuleModal"
      :marketing_goal="marketing_goal"
      :ad_id="ad_id"
      :monitor_type="monitor_type"
      :advertiser_id="advertiser_id"
      @closeRuleModal="closeRuleModal"
    />

    <WarnScRuleModal
      v-if="showScRuleModal"
      :visible="showScRuleModal"
      :new_ad_id="ad_id"
      :marketing_goal="marketing_goal"
      :advertiser_id="advertiser_id"
      @closeRuleModal="closeScRuleModal"
    />

    <a-drawer
      :visible="allOrderDrawer"
      class="authAccount"
      title="多账户商品计划对比"
      width="80%"
      placement="right"
      @close="
        selectedRow = [];
        selectedRowKeys = [];
        allOrderDrawer = false;
      "
      :bodyStyle="{ overflow: 'auto', height: 'calc(100% - 161px)' }"
    >
      <div style="display: flex; align-items: center; margin-bottom: 8px">
        <!-- <a-select
            class="filterItem"
            v-model="selectedAdvertiser"
            :maxTagCount="2"
            mode="multiple"
            style="width: 500px"
            placeholder="请选择要监控的户"
            @change="handleAdversterChange"
            :filterOption="filterOption"
            showSearch
          >
            <a-select-option
              v-for="(item, index) in filteredAdvertiserList"
              :key="index"
              :value="item.advertiser_id"
            >
              {{ item.advertiser_name }} ({{ item.advertiser_id }})
            </a-select-option>
          </a-select> -->

        <a-select
          ref="advertiserSelect"
          :value="selectedAdvertiser"
          placeholder="选择需要操作的户"
          mode="multiple"
          style="width: 500px"
          :maxTagCount="1"
          @change="handleAdversterChange"
          show-search
          :filter-option="filterOption"
          option-filter-prop="children"
          :autoClearSearchValue="false"
        >
          <a-select-option
            v-for="(item, index) in filteredAdvertiserList"
            :key="index"
            :value="item.advertiser_id"
          >
            {{ item.advertiser_name }} ({{ item.advertiser_id }})
          </a-select-option>
        </a-select>

        <a-button type="link" size="small" @click="selectAllFilteredAdvertisers"
          >全选</a-button
        >
        <a-button type="link" size="small" @click="clearAllAdvertisers"
          >清空</a-button
        >

        <a-select
          v-model="all_status"
          style="width: 140px; margin-right: 10px"
          placeholder="全部计划状态"
        >
          <a-select-option
            v-for="(item, index) in statusData"
            :key="index"
            :value="item.value"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>

        <a-input-search
          v-model="all_order_id"
          style="width: 350px; margin-left: 0px"
          placeholder="ID/名称"
          enter-button
          @search="onSearchAllKey"
        >
          <a-select
            slot="addonBefore"
            :default-value="all_order_type"
            @change="changeAllTypeAction"
            style="width: 80px"
          >
            <a-select-option value="PRODUCT"> 商品 </a-select-option>
            <a-select-option value="AD"> 计划 </a-select-option>
            <a-select-option value="AWEME"> 抖音号 </a-select-option>
          </a-select>
        </a-input-search>
      </div>
      <a-progress
        :percent="parseInt((succ / selectedAdvertiser.length) * 100)"
        size="small"
      />
      <Action
        ref="action"
        v-if="selectedRowKeys.length > 0 && allOrderDrawer"
        :selectedRowKeys="selectedRowKeys"
        :smart_bid_type="smart_bid_type"
        :dataMap="dataAllMap"
        @clearSelect="clearSelect"
      ></Action>
      <a-table
        ref="inOrderTable"
        :columns="columns"
        :data-source="paginatedAlldata"
        :pagination="allTablePagination"
        @change="handleAllTableChange"
        :sortDirections="['descend', 'ascend', '']"
        :rowKey="(record) => record.ad_info.id"
        :rowSelection="{
          selectedRowKeys,
          onChange: onSelectChange,
          getCheckboxProps: (record) => ({
            props: {
              disabled: parseInt(record.ad_info.id) < 10000,
            },
          }),
        }"
        :scroll="{ x: 2000 }"
        :loading="spinning_all"
      >
        <div
          slot="ad"
          class="aweme-right"
          slot-scope="text"
          style="width: 200px"
        >
          <div>
            <a-tag color="purple">{{ text.advertiser_name }}</a-tag>
            <div style="color: #999; font-size: 12px">
              千川户ID：{{ text.advertiser_id
              }}<a-icon type="copy" @click="text_copy(text.advertiser_id)" />
            </div>
          </div>
          <div v-if="text.error" style="margin-top: 10px">
            <b style="color: red; font-size: 11px">{{ text.error }}</b>
          </div>
          <div v-if="text.error && text.error.indexOf('retry') > -1">
            <b v-if="text.loading" style="color: #999; font-size: 12px"
              >[重试中...]</b
            >
            <b
              v-else
              style="color: green; font-size: 12px; cursor: pointer"
              @click="retryGetAd(text)"
              >[重试]</b
            >
          </div>
          <div>
            <a-tooltip placement="top" :title="text.ad_info.name">
              <div class="aweme-title" @click="getDetail(text)">
                {{ text.ad_info.name }}
              </div>
            </a-tooltip>
          </div>
          <div style="display: flex" v-if="!text.error">
            <div>
              <a-switch
                size="small"
                :checked="text.ad_info.opt_status == 'ENABLE' ? true : false"
                :loading="switchloading"
                @change="onSwitchChange(text)"
              />
            </div>
            <div style="margin-left: 5px">
              <div>
                <a-popover
                  title="设置备注"
                  placement="bottom"
                  trigger="click"
                  :getPopupContainer="
                    (triggerNode) => {
                      return triggerNode.parentNode || document.body;
                    }
                  "
                >
                  <template slot="content">
                    <p>
                      <a-textarea
                        placeholder="设置备注"
                        v-model="remark"
                        style="width: 100%"
                      />
                    </p>
                    <p>
                      <a-button
                        type="primary"
                        icon="edit"
                        style="width: 100%; margin-top: 5px"
                        @click="setAdRemark(text)"
                        >设置备注</a-button
                      >
                    </p>
                  </template>
                  <span v-if="text.remark == ''"
                    >备注 <a-icon type="edit" style="cursor: pointer"
                  /></span>
                  <span
                    v-else
                    :title="text.remark"
                    class="remark"
                    @click="remark = text.remark"
                    >{{ text.remark }}
                    <a-icon type="edit" style="cursor: pointer"
                  /></span>
                </a-popover>
              </div>
              <div class="small">创建时间:{{ text.ad_info.create_time }}</div>
              <div class="small">
                ID:{{ text.ad_info.id }}
                <a-icon type="copy" @click="text_copy(text.ad_info.id)" />
              </div>

              <div class="small" v-if="text.monitor_info">
                <div>
                  <div v-if="text.is_white">
                    <span style="color: #333">
                      <a-icon type="wifi" /> 未监控</span
                    >
                    <a-tooltip
                      placement="topLeft"
                      title="取消加白计划，计划将会重新被监控"
                    >
                      <span
                        style="
                          color: #597ef7;
                          cursor: pointer;
                          margin-left: 10px;
                        "
                        @click="addwhite(text, 'del')"
                      >
                        取消加白</span
                      >
                    </a-tooltip>
                  </div>
                  <div v-else>
                    <span style="color: green"
                      ><a-icon type="wifi" /> 监控中</span
                    >
                    <span
                      style="color: #597ef7; cursor: pointer; margin-left: 10px"
                      @click="setmonitor(text)"
                      >监控计划</span
                    >
                    <span
                      style="color: #597ef7; cursor: pointer; margin-left: 10px"
                      @click="setScmonitor(text)"
                      >监控素材</span
                    >
                    <a-tooltip
                      placement="topLeft"
                      title="加入计划白名单后，该计划将不会被监控"
                    >
                      <span
                        style="
                          color: #597ef7;
                          cursor: pointer;
                          margin-left: 10px;
                          margin-right: 10px;
                        "
                        @click="addwhite(text, 'add')"
                      >
                        加白</span
                      >
                    </a-tooltip>
                    <span
                      style="color: #fa8c16; cursor: pointer"
                      v-if="text.is_monitor > 0"
                      @click="getMonitorlog(text)"
                    >
                      监控记录
                    </span>
                  </div>
                </div>
              </div>
              <div class="small" v-else>
                <div>
                  <span><a-icon type="wifi" /> 计划未配置</span>
                  <span
                    style="color: #597ef7; cursor: pointer; margin-left: 10px"
                    @click="setmonitor(text)"
                    >监控计划</span
                  >
                  <span
                    style="color: #597ef7; cursor: pointer; margin-left: 10px"
                    @click="setScmonitor(text)"
                    >监控素材</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!text.error"
          class="delivery_setting"
          slot="delivery_setting"
          slot-scope="text"
        >
          <div v-if="text.ad_info.budget">
            预算:{{ text.ad_info.budget }}元
            <span v-if="text.ad_info.budget_mode == 'BUDGET_MODE_DAY'"
              >/日</span
            >
            <span v-if="text.ad_info.budget_mode == 'BUDGET_MODE_TOTAL'"
              >/总</span
            >

            <a-popover
              title="设置预算"
              placement="bottom"
              trigger="click"
              v-model="popoverVisibleMap[`${text.ad_info.id}_2`]"
              :getPopupContainer="
                (triggerNode) => {
                  return triggerNode.parentNode || document.body;
                }
              "
            >
              <template slot="content">
                <p>
                  <a-input
                    placeholder="预算需要在300~9999999.99之间"
                    v-model="new_budget"
                  />
                </p>
                <p>
                  <a-button
                    type="primary"
                    style="width: 100%; margin-top: 10px"
                    @click="editOne(text, new_budget, 2)"
                    :loading="btnloadiong"
                    >确定</a-button
                  >
                </p>
              </template>
              <a-icon type="edit" @click="new_budget = text.ad_info.budget" />
            </a-popover>
          </div>
          <div v-if="text.ad_info.roi2_goal">
            ROI目标:{{ text.ad_info.roi2_goal }}

            <a-popover
              title="设置ROI目标"
              placement="bottom"
              trigger="click"
              v-model="popoverVisibleMap[`${text.ad_info.id}_3`]"
              :getPopupContainer="
                (triggerNode) => {
                  return triggerNode.parentNode || document.body;
                }
              "
            >
              <template slot="content">
                <p><a-input placeholder="ROI目标" v-model="new_roi" /></p>
                <p>
                  <a-button
                    type="primary"
                    style="width: 100%; margin-top: 10px"
                    @click="editOne(text, new_roi, 3)"
                    :loading="btnloadiong"
                    >确定</a-button
                  >
                </p>
              </template>
              <a-icon type="edit" @click="new_roi = text.ad_info.roi2_goal" />
            </a-popover>
          </div>

          <div>
            <a-progress
              :percent="
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                )
              "
              size="small"
              status="active"
              v-if="
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                ) < 70
              "
            />
            <a-progress
              strokeColor="#f5222d"
              :percent="
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                )
              "
              size="small"
              status="active"
              v-else-if="
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                ) < 100 &&
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                ) >= 70
              "
            />
            <a-progress
              :percent="
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                )
              "
              size="small"
              v-else
            />
          </div>
        </div>

        <div v-if="!text.error" slot="aweme" slot-scope="text">
          <div class="aweme-id" v-if="text?.room_info?.[0]?.anchor_avatar">
            <div class="aweme-id-left">
              <img
                :src="text?.room_info?.[0]?.anchor_avatar"
                style="border-radius: 50%"
              />
            </div>
            <div class="aweme-id-right">
              <h6>{{ text.room_info?.[0].anchor_name }}</h6>
              <p>
                抖音ID:{{ text?.room_info?.[0]?.anchor_id }}
                <a-icon
                  type="copy"
                  @click="text_copy(text?.room_info?.[0].anchor_id)"
                />
              </p>
            </div>
          </div>
          <div v-for="(it, i) in text.product_info" :key="i">
            <div class="aweme-id">
              <div class="aweme-id-left">
                <img
                  :src="it.product_image"
                  style="border-radius: 3px"
                  @click="goDetail(it.product_id)"
                />
              </div>
              <div class="aweme-id-right">
                <div style="display: flex">
                  <h6>{{ it.product_name }}</h6>
                  <a-popover
                    title="设置商品佣金率"
                    placement="bottom"
                    trigger="click"
                    :getPopupContainer="
                      (triggerNode) => {
                        return triggerNode.parentNode || document.body;
                      }
                    "
                  >
                    <template slot="content">
                      <p>
                        <a-input-number
                          placeholder="商品佣金率"
                          style="width: 100%"
                          min="0"
                          max="100"
                          v-model="commission_rate"
                        />
                      </p>
                      <p>
                        <a-button
                          type="primary"
                          style="width: 100%; margin-top: 10px"
                          @click="
                            set_commission_rate(
                              text.advertiser_id,
                              text?.room_info?.[0]?.anchor_id,
                              it.product_id,
                              commission_rate
                            )
                          "
                          :loading="btnloadiong"
                          >确定</a-button
                        >
                      </p>
                    </template>
                    <b style="font-size: 12px; color: green"
                      >【{{ it.commission_rate }}%】</b
                    >
                  </a-popover>
                </div>
                <p>
                  ID:{{ it.product_id }}
                  <a-icon
                    type="copy"
                    @click="text_copy(it.product_id)"
                    style="margin-left: 10px; margin-right: 10px"
                  />
                  <a-icon
                    type="swap"
                    @click="
                      all_order_id = it.product_id;
                      alldata = [];
                      succ = 0;
                      allOrderDrawer = true;
                    "
                  />
                </p>
              </div>
            </div>
            <div class="statistic-wrapper" style="display: none;">
              <div class="statistic-item" style="margin-bottom: 0px">
                <p class="label">全部销售额</p>
                <p class="value">{{ it.total_pay_amount_str }}</p>
              </div>
              <div class="statistic-item" style="margin-bottom: 0px">
                <p class="label">有效销售额</p>
                <p class="value">{{ it.valid_total_pay_amount_str }}</p>
              </div>
              <div class="statistic-item" style="margin-bottom: 0px">
                <p class="label">退款销售额</p>
                <p class="value">{{ it.refund_total_pay_amount_str }}</p>
              </div>
              <div class="statistic-item" style="margin-top: 0px">
                <p class="label">全部佣金</p>
                <p class="value">{{ it.estimated_total_commission_str }}</p>
              </div>
              <div class="statistic-item" style="margin-top: 0px">
                <p class="label">有效佣金</p>
                <p class="value">
                  {{ it.valid_estimated_total_commission_str }}
                </p>
              </div>
              <div class="statistic-item" style="margin-top: 0px">
                <p class="label">退货率</p>
                <p class="value">{{ it.refund_rate }}%</p>
              </div>
            </div>
          </div>
        </div>

        <template slot="zt" slot-scope="text" v-if="!text.error">
          
          <a-tooltip
                    placement="top"
                    title="成本保障生效中"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'IN_EFFECT'"
                  >
                    <a-tag color="cyan"> 保 </a-tag>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="成本保障已失效"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'INVALID'"
                  >
                    <a-tag color="pink"> 保 </a-tag>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="成本保障确认中"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'CONFIRMING'"
                  >
                    <a-tag color="orange"> 保 </a-tag>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="成本保障已到账"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'PAID'"
                  >
                    <a-tag color="blue"> 保 </a-tag>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="成本保障已结束"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'ENDED'"
                  >
                    <a-tag color="purple"> 保 </a-tag>
                  </a-tooltip>
                  <a-tooltip
                    placement="top"
                    title="无成本保障状态"
                    v-if="text?.ad_info?.compensate_info?.compensate_status == 'DEFAULT'"
                  >
                    <a-tag color="#f50"> 保 </a-tag>
                  </a-tooltip>

          <div v-if="text.ad_info.status == 'DELIVERY_OK'">
            <a-tag color="green"> 投放中 </a-tag>
          </div>
          <div v-else>
            <a-tag color="red">
              {{ getStatusName(text.ad_info.status) }}
            </a-tag>
          </div>
        </template>
        <template slot="order_cencus" slot-scope="text">
                
                <div class="statistic-wrapper" style="background: none; padding: 0px;">
                    <div class="statistic-item" style="margin-bottom: 10px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">全部销售额</p>
                      <p class="value">{{ text.stats_info.all_total_pay_amount_str }}</p>
                    </div>
                    <div class="statistic-item" style="margin-bottom: 10px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">有效销售额</p>
                      <p class="value">{{ text.stats_info.all_valid_total_pay_amount_str }}</p>
                    </div>
                    <div class="statistic-item" style="margin-bottom: 10px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">退款销售额</p>
                      <p class="value">{{ text.stats_info.all_refund_total_pay_amount_str }}</p>
                    </div>
                    <div class="statistic-item" style="margin-top: 0px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">全部佣金</p>
                      <p class="value">
                        {{ text.stats_info.all_estimated_total_commission_str }}
                      </p>
                    </div>
                    <div class="statistic-item" style="margin-top: 0px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">有效佣金</p>
                      <p class="value">
                        {{ text.stats_info.all_valid_estimated_total_commission_str }}
                      </p>
                    </div>
                    <div class="statistic-item" style="margin-top: 0px">
                      <p class="label" style="font-size: 14px;color: #333;margin-bottom: 5px;">退货率</p>
                      <p class="value">{{ text.stats_info.all_refund_rate }}%</p>
                    </div>
                  </div>
              </template>

        <div
          class="green-roi"
          slot="total_prepay_and_pay_order_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          <b
            v-if="text.stats_info.total_prepay_and_pay_order_roi2 > 0"
            style="color: green"
            >{{ text.stats_info.total_prepay_and_pay_order_roi2 }}</b
          >
          <b v-else style="color: red">0</b>
        </div>

        <div slot="stat_cost" slot-scope="text" v-if="!text.error">
          {{ text.stats_info.stat_cost }}
        </div>

        <div
          slot="total_pay_order_gmv_for_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.total_pay_order_gmv_for_roi2 }}
        </div>

        <div
          slot="total_pay_order_count_for_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.total_pay_order_count_for_roi2 }}
        </div>

        <div
          slot="total_cost_per_pay_order_for_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.total_cost_per_pay_order_for_roi2 }}
        </div>

        <div
          slot="total_pay_order_coupon_amount_for_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.total_pay_order_coupon_amount_for_roi2 }}
        </div>

        <div
          slot="total_unfinished_estimate_order_gmv_for_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.total_unfinished_estimate_order_gmv_for_roi2 }}
        </div>

        <div
          slot="all_total_pay_amount_str"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.all_total_pay_amount_str }}
        </div>
        <div slot="all_total_count" slot-scope="text" v-if="!text.error">
          {{ text.stats_info.all_total_count }}
        </div>
        <div
          slot="all_estimated_total_commission_str"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.all_estimated_total_commission_str }}
        </div>

        <div
          slot="all_valid_total_pay_amount_str"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.all_valid_total_pay_amount_str }}
        </div>
        <div slot="all_valid_count" slot-scope="text" v-if="!text.error">
          {{ text.stats_info.all_valid_count }}
        </div>
        <div
          slot="all_valid_estimated_total_commission_str"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.all_valid_estimated_total_commission_str }}
        </div>

        <div
          slot="all_valid_total_pay_amount_str"
          slot-scope="text"
          v-if="!text.error"
        >
          <b style="color: green">{{
            text.stats_info.all_valid_total_pay_amount_str
          }}</b>
        </div>
        <div slot="all_valid_count" slot-scope="text" v-if="!text.error">
          <b style="color: green">{{ text.stats_info.all_valid_count }}</b>
        </div>
        <div
          slot="all_valid_estimated_total_commission_str"
          slot-scope="text"
          v-if="!text.error"
        >
          <b style="color: green">{{
            text.stats_info.all_valid_estimated_total_commission_str
          }}</b>
        </div>

        <div
          slot="all_refund_total_pay_amount_str"
          slot-scope="text"
          v-if="!text.error"
        >
          <b style="color: red">{{
            text.stats_info.all_refund_total_pay_amount_str
          }}</b>
        </div>
        <div slot="all_refund_count" slot-scope="text" v-if="!text.error">
          <b style="color: red">{{ text.stats_info.all_refund_count }}</b>
        </div>
        <div
          slot="all_refund_estimated_total_commission_str"
          slot-scope="text"
          v-if="!text.error"
        >
          <b style="color: red">{{
            text.stats_info.all_refund_estimated_total_commission_str
          }}</b>
        </div>

        <div slot="all_refund_rate" slot-scope="text" v-if="!text.error">
          <b style="color: red">{{ text.stats_info.all_refund_rate }} %</b>
        </div>

        <div slot="all_profit" slot-scope="text" v-if="!text.error">
          <b style="color: red" v-if="text.stats_info.all_profit < 0"
            >{{ text.stats_info.all_profit }} 元</b
          >
          <b style="color: green" v-else>{{ text.stats_info.all_profit }} 元</b>
        </div>

        <div slot="all_profit_rate" slot-scope="text" v-if="!text.error">
          <b style="color: red">{{ text.stats_info.all_profit_rate }} %</b>
        </div>

        <div
          style="cursor: pointer"
          slot="action"
          slot-scope="text, record"
          v-if="!text.error"
        >
          <div class="rowOperate">
            <span slot="action" class="actionItem" @click="getDetail(record)"
              >详情</span
            >
            <span
              slot="action"
              class="actionItem"
              @click="deleteAd(record)"
              style="color: red"
              >删除</span
            >
          </div>
        </div>
      </a-table>
    </a-drawer>

    <a-drawer
      :visible="suggestOrderDrawer"
      class="authAccount"
      title="审核建议/标签计划检测"
      width="80%"
      placement="right"
      @close="
        selectedRow = [];
        selectedRowKeys = [];
        suggestOrderDrawer = false;
      "
      :bodyStyle="{ overflow: 'auto', height: 'calc(100% - 161px)' }"
    >
      <a-alert
        message="使用该检测功能，请先前往素材监控板块开启监控配置,检测若出现频繁，请多次重试"
        banner
        type="info"
        show-icon
        style="cursor: pointer"
      />

      <div
        style="
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          margin-top: 8px;
        "
      >
        <a-select
          ref="advertiserSelect"
          :value="selectedAdvertiser"
          placeholder="选择需要操作的户"
          mode="multiple"
          style="width: 500px"
          :maxTagCount="1"
          @change="handleAdversterChange"
          show-search
          :filter-option="filterOption"
          option-filter-prop="children"
          :autoClearSearchValue="false"
        >
          <a-select-option
            v-for="(item, index) in filteredAdvertiserList"
            :key="index"
            :value="item.advertiser_id"
          >
            {{ item.advertiser_name }} ({{ item.advertiser_id }})
          </a-select-option>
        </a-select>
        <a-button type="link" size="small" @click="selectAllFilteredAdvertisers"
          >全选</a-button
        >
        <a-button type="link" size="small" @click="clearAllAdvertisers"
          >清空</a-button
        >
        <a-select
          v-model="all_status"
          style="width: 140px; margin-right: 10px"
          placeholder="全部计划状态"
        >
          <a-select-option
            v-for="(item, index) in statusData"
            :key="index"
            :value="item.value"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>

        <a-button type="primary" icon="search" @click="batchCheck()"
          >一键批量解析计划</a-button
        >
      </div>
      <div class="batch-btn">
        <a-alert
          :message="
            '当前已选择' +
            selectedAdvertiser.length +
            '户，今日已检测到当前获取到的审核建议计划数为' +
            suggestOrderList.length +
            '个最后更新时间：' +
            suggestOrderEndtime
          "
          banner
          type="success"
          show-icon
          style="cursor: pointer"
        />
      </div>
      <a-progress
        :percent="parseInt((succ / suggestOrderList.length) * 100)"
        size="small"
      />
      <Action
        ref="action"
        v-if="selectedRowKeys.length > 0 && suggestOrderDrawer"
        :selectedRowKeys="selectedRowKeys"
        :smart_bid_type="smart_bid_type"
        :dataMap="dataAllMap"
        @clearSelect="clearSelect"
      ></Action>
      <a-table
        ref="inOrderTable"
        :columns="columns"
        :data-source="alldata"
        :pagination="false"
        :sortDirections="['descend', 'ascend', '']"
        :rowKey="(record) => record.ad_info.id"
        :rowSelection="{
          selectedRowKeys,
          onChange: onSelectChange,
          getCheckboxProps: (record) => ({
            props: {
              disabled: parseInt(record.ad_info.id) < 10000,
            },
          }),
        }"
        :scroll="{ x: 2000 }"
        :loading="spinning_all"
      >
        <div
          slot="ad"
          class="aweme-right"
          slot-scope="text"
          style="width: 200px"
        >
          <div>
            <a-tag color="purple">{{ text.advertiser_name }}</a-tag>
            <div style="color: #999; font-size: 12px">
              千川户ID：{{ text.advertiser_id
              }}<a-icon type="copy" @click="text_copy(text.advertiser_id)" />
            </div>
          </div>
          <div v-if="text.error" style="margin-top: 10px">
            <b style="color: red; font-size: 11px">{{ text.error }}</b>
            <div v-if="text.error.indexOf('retry') > -1">
              <b v-if="text.loading" style="color: #999; font-size: 12px"
                >[重试中...]</b
              >
              <b
                v-else
                style="color: green; font-size: 12px; cursor: pointer"
                @click="retryGetAd(text, text.order_id, 'AD')"
                >[重试]</b
              >
            </div>
          </div>
          <div>
            <a-tooltip placement="top" :title="text.ad_info.name">
              <div class="aweme-title" @click="getDetail(text)">
                {{ text.ad_info.name }}
              </div>
            </a-tooltip>
          </div>
          <div style="display: flex" v-if="!text.error">
            <div>
              <a-switch
                size="small"
                :checked="text.ad_info.opt_status == 'ENABLE' ? true : false"
                :loading="switchloading"
                @change="onSwitchChange(text)"
              />
            </div>
            <div style="margin-left: 5px">
              <div>
                <a-popover
                  title="设置备注"
                  placement="bottom"
                  trigger="click"
                  :getPopupContainer="
                    (triggerNode) => {
                      return triggerNode.parentNode || document.body;
                    }
                  "
                >
                  <template slot="content">
                    <p>
                      <a-textarea
                        placeholder="设置备注"
                        v-model="remark"
                        style="width: 100%"
                      />
                    </p>
                    <p>
                      <a-button
                        type="primary"
                        icon="edit"
                        style="width: 100%; margin-top: 5px"
                        @click="setAdRemark(text)"
                        >设置备注</a-button
                      >
                    </p>
                  </template>
                  <span v-if="text.remark == ''"
                    >备注 <a-icon type="edit" style="cursor: pointer"
                  /></span>
                  <span
                    v-else
                    :title="text.remark"
                    class="remark"
                    @click="remark = text.remark"
                    >{{ text.remark }}
                    <a-icon type="edit" style="cursor: pointer"
                  /></span>
                </a-popover>
              </div>
              <div class="small">创建时间:{{ text.ad_info.create_time }}</div>
              <div class="small">
                ID:{{ text.ad_info.id }}
                <a-icon type="copy" @click="text_copy(text.ad_info.id)" />
              </div>

              <div class="small" v-if="text.monitor_info">
                <div>
                  <div v-if="text.is_white">
                    <span style="color: #333">
                      <a-icon type="wifi" /> 未监控</span
                    >
                    <a-tooltip
                      placement="topLeft"
                      title="取消加白计划，计划将会重新被监控"
                    >
                      <span
                        style="
                          color: #597ef7;
                          cursor: pointer;
                          margin-left: 10px;
                        "
                        @click="addwhite(text, 'del')"
                      >
                        取消加白</span
                      >
                    </a-tooltip>
                  </div>
                  <div v-else>
                    <span style="color: green"
                      ><a-icon type="wifi" /> 监控中</span
                    >
                    <span
                      style="color: #597ef7; cursor: pointer; margin-left: 10px"
                      @click="setmonitor(text)"
                      >监控计划</span
                    >
                    <span
                      style="color: #597ef7; cursor: pointer; margin-left: 10px"
                      @click="setScmonitor(text)"
                      >监控素材</span
                    >
                    <a-tooltip
                      placement="topLeft"
                      title="加入计划白名单后，该计划将不会被监控"
                    >
                      <span
                        style="
                          color: #597ef7;
                          cursor: pointer;
                          margin-left: 10px;
                          margin-right: 10px;
                        "
                        @click="addwhite(text, 'add')"
                      >
                        加白</span
                      >
                    </a-tooltip>
                    <span
                      style="color: #fa8c16; cursor: pointer"
                      v-if="text.is_monitor > 0"
                      @click="getMonitorlog(text)"
                    >
                      监控记录
                    </span>
                  </div>
                </div>
              </div>
              <div class="small" v-else>
                <div>
                  <span><a-icon type="wifi" /> 计划未配置</span>
                  <span
                    style="color: #597ef7; cursor: pointer; margin-left: 10px"
                    @click="setmonitor(text)"
                    >监控计划</span
                  >
                  <span
                    style="color: #597ef7; cursor: pointer; margin-left: 10px"
                    @click="setScmonitor(text)"
                    >监控素材</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!text.error"
          class="delivery_setting"
          slot="delivery_setting"
          slot-scope="text"
        >
          <div v-if="text.ad_info.budget">
            预算:{{ text.ad_info.budget }}元
            <span v-if="text.ad_info.budget_mode == 'BUDGET_MODE_DAY'"
              >/日</span
            >
            <span v-if="text.ad_info.budget_mode == 'BUDGET_MODE_TOTAL'"
              >/总</span
            >

            <a-popover
              title="设置预算"
              placement="bottom"
              trigger="click"
              v-model="popoverVisibleMap[`${text.ad_info.id}_2`]"
              :getPopupContainer="
                (triggerNode) => {
                  return triggerNode.parentNode || document.body;
                }
              "
            >
              <template slot="content">
                <p>
                  <a-input
                    placeholder="预算需要在300~9999999.99之间"
                    v-model="new_budget"
                  />
                </p>
                <p>
                  <a-button
                    type="primary"
                    style="width: 100%; margin-top: 10px"
                    @click="editOne(text, new_budget, 2)"
                    :loading="btnloadiong"
                    >确定</a-button
                  >
                </p>
              </template>
              <a-icon type="edit" @click="new_budget = text.ad_info.budget" />
            </a-popover>
          </div>
          <div v-if="text.ad_info.roi2_goal">
            ROI目标:{{ text.ad_info.roi2_goal }}

            <a-popover
              title="设置ROI目标"
              placement="bottom"
              trigger="click"
              v-model="popoverVisibleMap[`${text.ad_info.id}_3`]"
              :getPopupContainer="
                (triggerNode) => {
                  return triggerNode.parentNode || document.body;
                }
              "
            >
              <template slot="content">
                <p><a-input placeholder="ROI目标" v-model="new_roi" /></p>
                <p>
                  <a-button
                    type="primary"
                    style="width: 100%; margin-top: 10px"
                    @click="editOne(text, new_roi, 3)"
                    :loading="btnloadiong"
                    >确定</a-button
                  >
                </p>
              </template>
              <a-icon type="edit" @click="new_roi = text.ad_info.roi2_goal" />
            </a-popover>
          </div>

          <div>
            <a-progress
              :percent="
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                )
              "
              size="small"
              status="active"
              v-if="
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                ) < 70
              "
            />
            <a-progress
              strokeColor="#f5222d"
              :percent="
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                )
              "
              size="small"
              status="active"
              v-else-if="
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                ) < 100 &&
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                ) >= 70
              "
            />
            <a-progress
              :percent="
                parseInt(
                  (text.stats_info.stat_cost / text.ad_info.budget) * 100
                )
              "
              size="small"
              v-else
            />
          </div>
        </div>

        <div v-if="!text.error" slot="aweme" slot-scope="text">
          <div class="aweme-id" v-if="text?.room_info?.[0]?.anchor_avatar">
            <div class="aweme-id-left">
              <img
                :src="text?.room_info?.[0]?.anchor_avatar"
                style="border-radius: 50%"
              />
            </div>
            <div class="aweme-id-right">
              <h6>{{ text.room_info?.[0].anchor_name }}</h6>
              <p>
                抖音ID:{{ text?.room_info?.[0]?.anchor_id }}
                <a-icon
                  type="copy"
                  @click="text_copy(text?.room_info?.[0].anchor_id)"
                />
              </p>
            </div>
          </div>
          <div v-for="(it, i) in text.product_info" :key="i">
            <div class="aweme-id">
              <div class="aweme-id-left">
                <img
                  :src="it.product_image"
                  style="border-radius: 3px"
                  @click="goDetail(it.product_id)"
                />
              </div>
              <div class="aweme-id-right">
                <div style="display: flex">
                  <h6>{{ it.product_name }}</h6>
                  <b style="font-size: 12px; color: green"
                    >【{{ it.commission_rate }}%】</b
                  >
                </div>
                <p>
                  ID:{{ it.product_id }}
                  <a-icon
                    type="copy"
                    @click="text_copy(it.product_id)"
                    style="margin-left: 10px; margin-right: 10px"
                  />
                  <a-icon
                    type="swap"
                    @click="
                      all_order_id = it.product_id;
                      alldata = [];
                      succ = 0;
                      allOrderDrawer = true;
                    "
                  />
                </p>
              </div>
            </div>
            <div class="statistic-wrapper">
              <div class="statistic-item" style="margin-bottom: 0px">
                <p class="label">全部销售额</p>
                <p class="value">{{ it.total_pay_amount_str }}</p>
              </div>
              <div class="statistic-item" style="margin-bottom: 0px">
                <p class="label">有效销售额</p>
                <p class="value">{{ it.valid_total_pay_amount_str }}</p>
              </div>
              <div class="statistic-item" style="margin-bottom: 0px">
                <p class="label">退款销售额</p>
                <p class="value">{{ it.refund_total_pay_amount_str }}</p>
              </div>
              <div class="statistic-item" style="margin-top: 0px">
                <p class="label">全部佣金</p>
                <p class="value">{{ it.estimated_total_commission_str }}</p>
              </div>
              <div class="statistic-item" style="margin-top: 0px">
                <p class="label">有效佣金</p>
                <p class="value">
                  {{ it.valid_estimated_total_commission_str }}
                </p>
              </div>
              <div class="statistic-item" style="margin-top: 0px">
                <p class="label">退货率</p>
                <p class="value">{{ it.refund_rate }}%</p>
              </div>
            </div>
          </div>
        </div>

        <template slot="zt" slot-scope="text" v-if="!text.error">
          <div v-if="text.ad_info.status == 'DELIVERY_OK'">
            <a-tag color="green"> 投放中 </a-tag>
          </div>
          <div v-else>
            <a-tag color="red">
              {{ getStatusName(text.ad_info.status) }}
            </a-tag>
          </div>
        </template>

        <div
          class="green-roi"
          slot="total_prepay_and_pay_order_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          <b
            v-if="text.stats_info.total_prepay_and_pay_order_roi2 > 0"
            style="color: green"
            >{{ text.stats_info.total_prepay_and_pay_order_roi2 }}</b
          >
          <b v-else style="color: red">0</b>
        </div>

        <div slot="stat_cost" slot-scope="text" v-if="!text.error">
          {{ text.stats_info.stat_cost }}
        </div>

        <div
          slot="total_pay_order_gmv_for_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.total_pay_order_gmv_for_roi2 }}
        </div>

        <div
          slot="total_pay_order_count_for_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.total_pay_order_count_for_roi2 }}
        </div>

        <div
          slot="total_cost_per_pay_order_for_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.total_cost_per_pay_order_for_roi2 }}
        </div>

        <div
          slot="total_pay_order_coupon_amount_for_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.total_pay_order_coupon_amount_for_roi2 }}
        </div>

        <div
          slot="total_unfinished_estimate_order_gmv_for_roi2"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.total_unfinished_estimate_order_gmv_for_roi2 }}
        </div>

        <div
          slot="all_total_pay_amount_str"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.all_total_pay_amount_str }}
        </div>
        <div slot="all_total_count" slot-scope="text" v-if="!text.error">
          {{ text.stats_info.all_total_count }}
        </div>
        <div
          slot="all_estimated_total_commission_str"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.all_estimated_total_commission_str }}
        </div>

        <div
          slot="all_valid_total_pay_amount_str"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.all_valid_total_pay_amount_str }}
        </div>
        <div slot="all_valid_count" slot-scope="text" v-if="!text.error">
          {{ text.stats_info.all_valid_count }}
        </div>
        <div
          slot="all_valid_estimated_total_commission_str"
          slot-scope="text"
          v-if="!text.error"
        >
          {{ text.stats_info.all_valid_estimated_total_commission_str }}
        </div>

        <div
          slot="all_valid_total_pay_amount_str"
          slot-scope="text"
          v-if="!text.error"
        >
          <b style="color: green">{{
            text.stats_info.all_valid_total_pay_amount_str
          }}</b>
        </div>
        <div slot="all_valid_count" slot-scope="text" v-if="!text.error">
          <b style="color: green">{{ text.stats_info.all_valid_count }}</b>
        </div>
        <div
          slot="all_valid_estimated_total_commission_str"
          slot-scope="text"
          v-if="!text.error"
        >
          <b style="color: green">{{
            text.stats_info.all_valid_estimated_total_commission_str
          }}</b>
        </div>

        <div
          slot="all_refund_total_pay_amount_str"
          slot-scope="text"
          v-if="!text.error"
        >
          <b style="color: red">{{
            text.stats_info.all_refund_total_pay_amount_str
          }}</b>
        </div>
        <div slot="all_refund_count" slot-scope="text" v-if="!text.error">
          <b style="color: red">{{ text.stats_info.all_refund_count }}</b>
        </div>
        <div
          slot="all_refund_estimated_total_commission_str"
          slot-scope="text"
          v-if="!text.error"
        >
          <b style="color: red">{{
            text.stats_info.all_refund_estimated_total_commission_str
          }}</b>
        </div>

        <div slot="all_refund_rate" slot-scope="text" v-if="!text.error">
          <b style="color: red">{{ text.stats_info.all_refund_rate }} %</b>
        </div>

        <div slot="all_profit" slot-scope="text" v-if="!text.error">
          <b style="color: red" v-if="text.stats_info.all_profit < 0"
            >{{ text.stats_info.all_profit }} 元</b
          >
          <b style="color: green" v-else>{{ text.stats_info.all_profit }} 元</b>
        </div>

        <div slot="all_profit_rate" slot-scope="text" v-if="!text.error">
          <b style="color: red">{{ text.stats_info.all_profit_rate }} %</b>
        </div>

        <div
          style="cursor: pointer"
          slot="action"
          slot-scope="text, record"
          v-if="!text.error"
        >
          <div class="rowOperate">
            <span slot="action" class="actionItem" @click="getDetail(record)"
              >详情</span
            >
            <span
              slot="action"
              class="actionItem"
              @click="deleteAd(record)"
              style="color: red"
              >删除</span
            >
          </div>
        </div>
      </a-table>
    </a-drawer>

    <!-- 商品详情抽屉 -->
    <a-drawer
      title="商品详情"
      placement="right"
      :visible="productDrawerVisible"
      width="1200px"
      @close="closeProductDrawer"
    >
      <div v-if="currentProductList.length > 0">
        <div style="margin-bottom: 20px;">
          <h3>{{ currentAdTitle }}</h3>
          <p style="color: #666;">共 {{ currentProductList.length }} 个商品</p>
        </div>
        
        <a-table
          :dataSource="currentProductList"
          :rowKey="(record, index) => index"
          :pagination="false"
          :scroll="{ y: 'calc(100vh - 200px)' }"
        >
          <a-table-column title="商品信息" align="left" width="350px" >
            <template slot-scope="text, record">
              <div class="aweme-id">
                <div class="aweme-id-left" style="width: 70px;">
                  <img
                    :src="record.product_image"
                    style="border-radius: 3px; width: 60px; height: 60px; object-fit: cover;"
                    @click="goDetail(record.product_id)"
                  />
                </div>
                <div class="aweme-id-right">
                  <div style="display: flex; align-items: center;">
                    <h6 style="margin: 0; margin-right: 10px;">{{ record.product_name }}</h6>
                    <a-popover
                      title="设置商品佣金率"
                      placement="bottom"
                      trigger="click"
                      :getPopupContainer="
                        (triggerNode) => {
                          return triggerNode.parentNode || document.body;
                        }
                      "
                    >
                      <template slot="content">
                        <p>
                          <a-input-number
                            placeholder="商品佣金率"
                            style="width: 100%"
                            min="0"
                            max="100"
                            v-model="commission_rate"
                          />
                        </p>
                        <p>
                          <a-button
                            type="primary"
                            style="width: 100%; margin-top: 10px"
                            @click="
                              set_commission_rate(
                                currentAdId,
                                record.anchor_id,
                                record.product_id,
                                commission_rate
                              )
                            "
                            :loading="btnloadiong"
                            >确定</a-button
                          >
                        </p>
                      </template>
                      <b style="font-size: 12px; color: green">【{{ record.commission_rate }}%】</b>
                    </a-popover>
                  </div>
                  <p style="margin: 5px 0;">
                    ID:{{ record.product_id }}
                    <a-icon
                      type="copy"
                      @click="text_copy(record.product_id)"
                      style="margin-left: 10px; margin-right: 10px"
                    />
                    <a-icon
                      type="swap"
                      @click="
                        all_order_id = record.product_id;
                        alldata = [];
                        succ = 0;
                        allOrderDrawer = true;
                      "
                    />
                  </p>
                </div>
              </div>
            </template>
          </a-table-column>
          
          <a-table-column title="全部销售额" align="center">
            <template slot-scope="text, record">
              {{ record.total_pay_amount_str }}
            </template>
          </a-table-column>
          
          <a-table-column title="有效销售额" align="center">
            <template slot-scope="text, record">
              {{ record.valid_total_pay_amount_str }}
            </template>
          </a-table-column>
          
          <a-table-column title="退款销售额" align="center">
            <template slot-scope="text, record">
              {{ record.refund_total_pay_amount_str }}
            </template>
          </a-table-column>
          
          <a-table-column title="全部佣金" align="center">
            <template slot-scope="text, record">
              {{ record.estimated_total_commission_str }}
            </template>
          </a-table-column>
          
          <a-table-column title="有效佣金" align="center">
            <template slot-scope="text, record">
              {{ record.valid_estimated_total_commission_str }}
            </template>
          </a-table-column>
          
          <a-table-column title="退货率" align="center">
            <template slot-scope="text, record">
              {{ record.refund_rate }}%
            </template>
          </a-table-column>
        </a-table>
      </div>
      <div v-else style="text-align: center; padding: 50px;">
        <a-empty description="暂无商品数据" />
      </div>
    </a-drawer>

    <!-- 自定义列配置弹窗 -->
    <a-modal
      title="自定义列"
      :visible="columnConfigVisible"
      @ok="saveColumnConfig"
      @cancel="closeColumnConfigModal"
      :width="700"
      okText="确定"
      cancelText="取消"
    >
      <div>
        <div
          v-for="(col, index) in sortedColumns"
          :key="col.key"
          style="padding: 8px 0; border-bottom: 1px solid #f0f0f0; display: flex; align-items: center; justify-content: space-between;"
        >
          <div style="flex: 1; display: flex; align-items: center;">
            <a-checkbox
              :checked="selectedColumnKeys.includes(col.key)"
              @change="(e) => handleColumnCheckChange(col.key, e.target.checked)"
              :disabled="col.fixed !== undefined"
              style="margin-right: 8px;"
            >
              {{ col.title }}
              <span v-if="col.fixed !== undefined" style="color: #999; font-size: 12px;">
                (固定列)
              </span>
            </a-checkbox>
          </div>
          <div v-if="!col.fixed" style="display: flex; gap: 8px;">
            <a-button
              type="link"
              size="small"
              icon="arrow-up"
              :disabled="index === 0 || sortedColumns[index - 1].fixed !== undefined"
              @click="moveColumnUp(index)"
              title="上移"
            />
            <a-button
              type="link"
              size="small"
              icon="arrow-down"
              :disabled="index === sortedColumns.length - 1 || sortedColumns[index + 1].fixed !== undefined"
              @click="moveColumnDown(index)"
              title="下移"
            />
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { qcApi, requestHttp } from '@utils/index';
import { Modal } from 'ant-design-vue';
import Detail from './components/detail.vue';
import Action from './components/action.vue';
import WarnRuleModal from '../../../monitorManage/commponents/warnRuleModal.vue';
import WarnScRuleModal from '../../../materialMonitor/commponents/warnRuleModal.vue';

import moment from 'moment';
import { get } from 'store';
const columns = [
  {
    title: '计划信息',
    key: 'ad',
    width: 280,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'ad' },
    fixed: 'left',
  },
  {
    title: '投放信息',
    key: 'aweme',
    width: 300,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'aweme' },
    // fixed: 'left',
  },
  {
    title: '计划状态',
    key: 'zt',
    width: 160,
    align: 'center',
    scopedSlots: { customRender: 'zt' },
  },
  {
    title: '预算/出价',
    key: 'delivery_setting',
    align: 'center',
    width: 180,
    scopedSlots: { customRender: 'delivery_setting' },
  },
  {
    title: '投流消耗',
    key: 'stat_cost',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'stat_cost' },
  },
  {
    title: '整体支付ROI',
    key: 'total_prepay_and_pay_order_roi2',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'total_prepay_and_pay_order_roi2' },
  },
  {
    title: '整体成交金额',
    key: 'total_pay_order_gmv_for_roi2',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'total_pay_order_gmv_for_roi2' },
  },
  {
    title: '成交单数',
    key: 'total_pay_order_count_for_roi2',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'total_pay_order_count_for_roi2' },
  },
  {
    title: '订单汇总',
    key: 'order_cencus',
    align: 'center',
    width: 250,
    scopedSlots: { customRender: 'order_cencus' },
  },

  // {
  //   title: '联盟有效销售额',
  //   key: 'all_valid_total_pay_amount_str',
  //   align: 'center',
  //   width: 120,
  //   scopedSlots: { customRender: 'all_valid_total_pay_amount_str' },
  // },
  // {
  //   title: '联盟有效订单',
  //   key: 'all_valid_count',
  //   align: 'center',
  //   width: 120,
  //   scopedSlots: { customRender: 'all_valid_count' },
  // },
  // {
  //   title: '联盟有效佣金',
  //   key: 'all_valid_estimated_total_commission_str',
  //   align: 'center',
  //   width: 120,
  //   scopedSlots: { customRender: 'all_valid_estimated_total_commission_str' },
  // },
  {
    title: '实际利润',
    key: 'all_profit',
    align: 'center',
    width: 120,
    scopedSlots: { customRender: 'all_profit' },
  },
  {
    title: '利润百分比',
    key: 'all_profit_rate',
    align: 'center',
    width: 120,
    scopedSlots: { customRender: 'all_profit_rate' },
  },
  {
    title: '净成交ROI',
    key: 'total_prepay_and_pay_settle_roi2_1h',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'total_prepay_and_pay_settle_roi2_1h' },
  },
  {
    title: '净成交金额',
    key: 'total_order_settle_amount_for_roi2_1h',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'total_order_settle_amount_for_roi2_1h' },
  },
  {
    title: '净成交订单数',
    key: 'total_order_settle_count_for_roi2_1h',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'total_order_settle_count_for_roi2_1h' },
  },
  {
    title: '整体成交订单成本',
    key: 'total_cost_per_pay_order_for_roi2',
    align: 'center',
    sorter: true,
    width: 150,
    scopedSlots: { customRender: 'total_cost_per_pay_order_for_roi2' },
  },
  {
    title: '整体成交智能优惠券金额',
    key: 'total_pay_order_coupon_amount_for_roi2',
    align: 'center',
    sorter: true,
    width: 150,
    scopedSlots: { customRender: 'total_pay_order_coupon_amount_for_roi2' },
  },
  {
    title: '整体成交金额(含券)',
    key: 'total_pay_order_gmv_include_coupon_for_roi2',
    align: 'center',
    sorter: true,
    width: 150,
    scopedSlots: { customRender: 'total_pay_order_gmv_include_coupon_for_roi2' },
  },
  {
    title: '电商平台补贴金额',
    key: 'total_ecom_platform_subsidy_amount_for_roi2',
    align: 'center',
    sorter: true,
    width: 150,
    scopedSlots: { customRender: 'total_ecom_platform_subsidy_amount_for_roi2' },
  },
  {
    title: '净成交订单成本',
    key: 'total_cost_per_pay_order_settle_for_roi2_1h',
    align: 'center',
    sorter: true,
    width: 150,
    scopedSlots: { customRender: 'total_cost_per_pay_order_settle_for_roi2_1h' },
  },
  {
    title: '用户实际支付净成交金额',
    key: 'total_order_real_settle_amount_for_roi2_1h',
    align: 'center',
    sorter: true,
    width: 180,
    scopedSlots: { customRender: 'total_order_real_settle_amount_for_roi2_1h' },
  },
  {
    title: '智能优惠券未退款金额',
    key: 'no_refund_ecom_coupon_amount_for_roi2',
    align: 'center',
    sorter: true,
    width: 180,
    scopedSlots: { customRender: 'no_refund_ecom_coupon_amount_for_roi2' },
  },
  {
    title: '电商平台补贴未退款金额',
    key: 'no_refund_ecom_platform_subsidy_amount_for_roi2',
    align: 'center',
    sorter: true,
    width: 180,
    scopedSlots: { customRender: 'no_refund_ecom_platform_subsidy_amount_for_roi2' },
  },
  {
    title: '净成交订单结算率',
    key: 'total_order_settle_count_rate_for_roi2_1h',
    align: 'center',
    sorter: true,
    width: 150,
    scopedSlots: { customRender: 'total_order_settle_count_rate_for_roi2_1h' },
  },
  {
    title: '净成交金额结算率',
    key: 'total_order_settle_amount_rate_for_roi2_1h',
    align: 'center',
    sorter: true,
    width: 150,
    scopedSlots: { customRender: 'total_order_settle_amount_rate_for_roi2_1h' },
  },
  {
    title: '1小时内退款订单数',
    key: 'total_refund_order_count_for_roi2_1h',
    align: 'center',
    sorter: true,
    width: 150,
    scopedSlots: { customRender: 'total_refund_order_count_for_roi2_1h' },
  },
  {
    title: '1小时内退款金额',
    key: 'total_refund_order_gmv_for_roi2_1h_all',
    align: 'center',
    sorter: true,
    width: 150,
    scopedSlots: { customRender: 'total_refund_order_gmv_for_roi2_1h_all' },
  },
  {
    title: '1小时内退款率',
    key: 'total_refund_order_gmv_for_roi2_1h_rate',
    align: 'center',
    sorter: true,
    width: 150,
    scopedSlots: { customRender: 'total_refund_order_gmv_for_roi2_1h_rate' },
  },
  {
    title: '整体未完结预售订单预估金额',
    key: 'total_unfinished_estimate_order_gmv_for_roi2',
    align: 'center',
    sorter: true,
    width: 150,
    scopedSlots: {
      customRender: 'total_unfinished_estimate_order_gmv_for_roi2',
    },
  },
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
];
const data = [];
const key = 'updatable';
export default {
  name: 'ShowTemplate',
  props: {
    advertiser_id: {
      type: String,
      default: '',
    },
    advertiserList: {
      type: Array,
    },
    marketing_goal: {
      type: String,
      default: '',
    },
    product_id: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      spinning: false,
      columns,
      data,
      status: '', // 分页参数
      all_status: '',
      report: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        hideOnSinglePage: false,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      page: 1,
      pagesize: 10,
      selectedRow: [],
      selectedRowKeys: [],
      statusData: [
        { name: '全部计划状态', value: '' },
        { name: '新建审核中', value: 'AUDIT' },
        { name: '已删除', value: 'DELETE' },
        { name: '投放中', value: 'DELIVERY_OK' },
        { name: '已暂停', value: 'DISABLE' },
        { name: '草稿', value: 'DRAFT' },
        { name: '数据错误', value: 'ERROR' },
        { name: '落地页暂不可用', value: 'EXTERNAL_URL_DISABLE' },
        { name: '已终止', value: 'FROZEN' },
        { name: '关联直播间未开播', value: 'LIVE_ROOM_OFF' },
        { name: '不在投放时段', value: 'NO_SCHEDULE' },
        { name: '审核不通过', value: 'OFFLINE_AUDIT' },
        { name: '账户余额不足', value: 'OFFLINE_BALANCE' },
        { name: '广告超出预算', value: 'OFFLINE_BUDGET' },
        { name: '预上线', value: 'PRE_ONLINE' },
        { name: 'QUOTA配额不足暂停计划', value: 'QUOTA_DISABLE' },
        { name: '修改审核中', value: 'REAUDIT' },
        { name: '全域推广暂停', value: 'ROI2_DISABLE' },
        { name: '系统暂停', value: 'SYSTEM_DISABLE' },
        { name: '已完成', value: 'TIME_DONE' },
        { name: '未到达投放时间', value: 'TIME_NO_REACH' },
        { name: '账户超出预算', value: 'ADVERTISER_OFFLINE_BUDGET' },
        { name: '账户接近预算', value: 'ADVERTISER_PRE_OFFLINE_BUDGET' },
        { name: '异常，请联系审核人员', value: 'AUDIT_STATUS_ERROR' },
        { name: '关联抖音号不可投', value: 'AWEME_ACCOUNT_DISABLED' },
        { name: '已被广告组暂停', value: 'CAMPAIGN_DISABLE' },
        { name: '广告组超出预算', value: 'CAMPAIGN_OFFLINE_BUDGET' },
        { name: '广告组接近预算', value: 'CAMPAIGN_PRE_OFFLINE_BUDGET' },
      ],
      smart_bid_type: 'SMART_BID_CUSTOM',
      ad: {},
      dataMap: {},
      dataAllMap: {},
      deadline: Date.now() + 1000 * 301,
      deadtitle: '定时刷新中：倒计时',
      sortby: 'ad_id',
      sort: 'descend',
      order_id: '',
      timeType: 'ALL',
      range_date: [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      range_create_date: [],
      timeday: '0',
      toploading: false,
      topkey: 1,
      switchloading: false,
      timer_status: true,
      releshBtn: false,
      xData: [],
      y1: [],
      y2: [],
      y3: [],
      y4: [],
      y5: [],
      y6: [],
      new_budget: '',
      new_bid: '',
      new_roi: '',
      tableKey: '1',
      totalItem: {
        stat_cost: '-',
        pay_order_amount: '-',
        prepay_and_pay_order_roi: '-',
        pay_order_count: '-',
      },
      logDrawer: false,
      log_data: [],
      remark: '',
      btnloadiong: false,
      showRuleModal: false,
      monitor_type: 'AD',
      ad_id: '',
      // 商品展开状态管理，key为商品ID，value为是否展开
      productExpandState: {},
      // 商品详情抽屉相关状态
      productDrawerVisible: false,
      currentProductList: [],
      currentAdId: '',
      currentAdTitle: '',
      showScRuleModal: false,
      having_cost: 'ALL',
      search_keyword_type: 'AD',
      allOrderDrawer: false,
      spinning_all: false,
      alldata: [],
      // 独立表格分页配置
      allTablePagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        hideOnSinglePage: false,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      selectedAdvertiser: [],
      all_order_id: '',
      all_order_type: 'PRODUCT',
      succ: 0,
      searchQuery: '',
      filteredAdvertiserList: [],
      post_advertiser_id: '',
      suggestOrderDrawer: false,
      suggestOrderList: [],
      suggestOrderEndtime: '',
      checktype: '',
      commission_rate: '',
      divide_into_rate: '',
      // popover 显示状态管理，key 为 '${adId}_${edittype}'，value 为 visible 状态
      popoverVisibleMap: {},
      // 自定义列配置相关
      columnConfigVisible: false, // 列配置弹窗显示状态
      allColumns: [], // 所有可配置的列
      selectedColumnKeys: [], // 选中的列key列表
      columnOrder: [], // 列的顺序（存储 key 数组）
      sortedColumns: [], // 排序后的列列表（用于弹窗显示）
      columnConfigCacheKey: 'show_template_column_config', // localStorage key
      // 搜索缓存：key为搜索条件hash，value为 {successData: Map<advertiser_id, data[]>, failedAdvertisers: Set<advertiser_id>}
      searchCache: new Map(),
    };
  },

  components: {
    Detail,
    Action,
    WarnRuleModal,
    WarnScRuleModal,
  },
  computed: {
    // 分页后的数据
    paginatedAlldata() {
      const { current, pageSize } = this.allTablePagination;
      const start = (current - 1) * pageSize;
      const end = start + pageSize;
      return this.alldata.slice(start, end);
    },
  },
  watch: {
    advertiserList: {
      immediate: true,
      handler(newVal) {
        this.filteredAdvertiserList = [...newVal];
      },
    },
    advertiser_id(a, b) {
      this.page = 1;
      this.pagination.current = 1;
      // 如果有 product_id，使用 product_id 查询，否则清空
      if (this.product_id) {
        this.order_id = this.product_id;
        this.search_keyword_type = 'PRODUCT';
        this.getData();
        this.getReport();
      } else {
        this.order_id = '';
        this.getData();
        this.getReport();
      }
      this.selectedRowKeys = [];
    },
    product_id: {
      immediate: true,
      handler(newVal, oldVal) {
        // 当 advertiser_id 存在时执行
        if (this.advertiser_id) {
          // 避免重复请求：只在值变化时或首次设置时执行
          if (newVal !== oldVal || oldVal === undefined) {
            // 重置分页
            this.page = 1;
            this.pagination.current = 1;
            
            // 如果 product_id 有值，设置商品搜索条件
            if (newVal) {
              this.order_id = newVal;
              this.search_keyword_type = 'PRODUCT';
            } else {
              // 如果 product_id 为空，清空搜索条件，查询账户所有计划
              this.order_id = '';
              this.search_keyword_type = 'AD';
            }
            
            // 执行查询
            this.$nextTick(() => {
              this.getData();
              this.getReport();
            });
          }
        }
      },
    },
  },

  mounted() {
    // 初始化列配置
    this.initColumnConfig();
    // 如果已有 advertiser_id，执行查询
    if (this.advertiser_id) {
      this.page = 1;
      this.pagination.current = 1;
      
      // 如果 product_id 有值，设置商品搜索条件
      if (this.product_id) {
        this.order_id = this.product_id;
        this.search_keyword_type = 'PRODUCT';
      } else {
        // 如果 product_id 为空，清空搜索条件，查询账户所有计划
        this.order_id = '';
        this.search_keyword_type = 'AD';
      }
      
      this.$nextTick(() => {
        this.getData();
        this.getReport();
      });
    }
  },

  methods: {
    moment,
    
    // 格式化金额（保留2位小数）
    formatAmount(value) {
      if (value === null || value === undefined || value === '') {
        return '0.00';
      }
      const num = parseFloat(value);
      if (isNaN(num)) {
        return '0.00';
      }
      return num.toFixed(2);
    },
    
    // 格式化数字（保留2位小数）
    formatNumber(value) {
      if (value === null || value === undefined || value === '') {
        return '0.00';
      }
      const num = parseFloat(value);
      if (isNaN(num)) {
        return '0.00';
      }
      return num.toFixed(2);
    },
    
    // 格式化百分比（乘以100，保留2位小数）
    formatPercent(value) {
      if (value === null || value === undefined || value === '') {
        return '0.00%';
      }
      const num = parseFloat(value);
      if (isNaN(num)) {
        return '0.00%';
      }
      return (num * 100).toFixed(2) + '%';
    },
    
    // 初始化列配置
    initColumnConfig() {
      // 保存所有列的原始定义（用于配置弹窗）
      this.allColumns = columns.map(col => ({
        ...col,
        visible: true,
      }));
      
      // 从 localStorage 读取配置
      const savedConfig = localStorage.getItem(this.columnConfigCacheKey);
      if (savedConfig) {
        try {
          const config = JSON.parse(savedConfig);
          this.selectedColumnKeys = config.selectedColumnKeys || [];
          this.columnOrder = config.columnOrder || columns.map(col => col.key);
          // 更新排序后的列列表
          this.updateSortedColumns();
          // 应用配置到 columns
          this.applyColumnConfig();
        } catch (error) {
          console.error('读取列配置失败:', error);
          // 如果读取失败，使用默认配置（显示所有列）
          this.selectedColumnKeys = columns.map(col => col.key);
          this.columnOrder = columns.map(col => col.key);
          this.updateSortedColumns();
          this.applyColumnConfig();
        }
      } else {
        // 如果没有保存的配置，默认显示所有列
        this.selectedColumnKeys = columns.map(col => col.key);
        this.columnOrder = columns.map(col => col.key);
        this.updateSortedColumns();
        this.applyColumnConfig();
      }
    },
    
    // 更新排序后的列列表
    updateSortedColumns() {
      // 按照 columnOrder 的顺序排列列
      const orderedColumns = [];
      const columnMap = new Map(this.allColumns.map(col => [col.key, col]));
      
      // 1. 先添加左侧固定列（fixed: 'left'）
      this.allColumns.forEach(col => {
        if (col.fixed === 'left' && !orderedColumns.find(c => c.key === col.key)) {
          orderedColumns.push(col);
        }
      });
      
      // 2. 然后按照 columnOrder 添加普通列
      this.columnOrder.forEach(key => {
        const col = columnMap.get(key);
        if (col && col.fixed === undefined && !orderedColumns.find(c => c.key === col.key)) {
          orderedColumns.push(col);
        }
      });
      
      // 3. 添加不在 columnOrder 中的普通列（新添加的列）
      this.allColumns.forEach(col => {
        if (col.fixed === undefined && !orderedColumns.find(c => c.key === col.key)) {
          orderedColumns.push(col);
        }
      });
      
      // 4. 最后添加右侧固定列（fixed: 'right'）
      this.allColumns.forEach(col => {
        if (col.fixed === 'right' && !orderedColumns.find(c => c.key === col.key)) {
          orderedColumns.push(col);
        }
      });
      
      this.sortedColumns = orderedColumns;
    },
    
    // 处理列的选中状态变化
    handleColumnCheckChange(key, checked) {
      if (checked) {
        if (!this.selectedColumnKeys.includes(key)) {
          this.selectedColumnKeys.push(key);
        }
      } else {
        const index = this.selectedColumnKeys.indexOf(key);
        if (index > -1) {
          this.selectedColumnKeys.splice(index, 1);
        }
      }
    },
    
    // 上移列
    moveColumnUp(index) {
      if (index === 0) return;
      // 找到上一个非固定列的索引
      let prevIndex = index - 1;
      while (prevIndex >= 0 && this.sortedColumns[prevIndex].fixed !== undefined) {
        prevIndex--;
      }
      if (prevIndex < 0) return;
      
      // 使用 Vue 的响应式方法交换位置
      const newColumns = [...this.sortedColumns];
      const temp = newColumns[index];
      newColumns[index] = newColumns[prevIndex];
      newColumns[prevIndex] = temp;
      this.sortedColumns = newColumns;
      
      // 更新 columnOrder
      this.updateColumnOrder();
    },
    
    // 下移列
    moveColumnDown(index) {
      if (index === this.sortedColumns.length - 1) return;
      // 找到下一个非固定列的索引
      let nextIndex = index + 1;
      while (nextIndex < this.sortedColumns.length && this.sortedColumns[nextIndex].fixed !== undefined) {
        nextIndex++;
      }
      if (nextIndex >= this.sortedColumns.length) return;
      
      // 使用 Vue 的响应式方法交换位置
      const newColumns = [...this.sortedColumns];
      const temp = newColumns[index];
      newColumns[index] = newColumns[nextIndex];
      newColumns[nextIndex] = temp;
      this.sortedColumns = newColumns;
      
      // 更新 columnOrder
      this.updateColumnOrder();
    },
    
    // 更新列顺序
    updateColumnOrder() {
      // 从 sortedColumns 中提取非固定列的 key
      this.columnOrder = this.sortedColumns
        .filter(col => col.fixed === undefined)
        .map(col => col.key);
    },
    
    // 应用列配置
    applyColumnConfig() {
      // 创建列映射
      const columnMap = new Map(columns.map(col => [col.key, col]));
      
      const result = [];
      
      // 1. 先添加左侧固定列（fixed: 'left'）
      const leftFixedColumns = columns.filter(col => col.fixed === 'left');
      leftFixedColumns.forEach(col => {
        result.push(col);
      });
      
      // 2. 然后按照 columnOrder 的顺序添加选中的普通列
      this.columnOrder.forEach(key => {
        if (this.selectedColumnKeys.includes(key)) {
          const col = columnMap.get(key);
          if (col && col.fixed === undefined && !result.find(c => c.key === col.key)) {
            result.push(col);
          }
        }
      });
      
      // 3. 添加不在 columnOrder 中但被选中的普通列（新添加的列）
      this.selectedColumnKeys.forEach(key => {
        const col = columnMap.get(key);
        if (col && col.fixed === undefined && !result.find(c => c.key === col.key)) {
          result.push(col);
        }
      });
      
      // 4. 最后添加右侧固定列（fixed: 'right'）
      const rightFixedColumns = columns.filter(col => col.fixed === 'right');
      rightFixedColumns.forEach(col => {
        result.push(col);
      });
      
      this.columns = result;
    },
    
    // 显示列配置弹窗
    showColumnConfigModal() {
      // 打开弹窗时，更新排序后的列列表
      this.updateSortedColumns();
      this.columnConfigVisible = true;
    },
    
    // 关闭列配置弹窗
    closeColumnConfigModal() {
      this.columnConfigVisible = false;
    },
    
    // 保存列配置
    saveColumnConfig() {
      // 确保固定列始终被选中
      const fixedColumnKeys = columns
        .filter(col => col.fixed !== undefined)
        .map(col => col.key);
      
      // 合并固定列和选中的列
      const allSelectedKeys = [
        ...new Set([...fixedColumnKeys, ...this.selectedColumnKeys])
      ];
      
      // 更新列顺序（从 sortedColumns 中提取）
      this.updateColumnOrder();
      
      // 保存到 localStorage
      const config = {
        selectedColumnKeys: allSelectedKeys,
        columnOrder: this.columnOrder,
        timestamp: Date.now(),
      };
      localStorage.setItem(this.columnConfigCacheKey, JSON.stringify(config));
      
      // 应用配置
      this.selectedColumnKeys = allSelectedKeys;
      this.applyColumnConfig();
      
      // 关闭弹窗
      this.closeColumnConfigModal();
      
      this.$message.success('列配置已保存');
    },
    
    // 获取要显示的商品列表
    getDisplayProducts(productInfo, adId) {
      if (!productInfo || productInfo.length === 0) {
        return [];
      }
      
      // 始终只显示第一个商品
      return [productInfo[0]];
    },
    
    closeOrderDrawer() {
      // this.getData();
    },
    
    // 打开商品详情抽屉
    openProductDrawer(productList, adId, adTitle) {
      this.currentProductList = productList;
      this.currentAdId = adId;
      this.currentAdTitle = adTitle;
      this.productDrawerVisible = true;
    },
    
    // 关闭商品详情抽屉
    closeProductDrawer() {
      this.productDrawerVisible = false;
      this.currentProductList = [];
      this.currentAdId = '';
      this.currentAdTitle = '';
    },
    showCheckOrder(t) {
      this.checktype = t;
      this.suggestOrderDrawer = true;
      this.selectedAdvertiser = [];
      this.suggestOrderList = [];
      this.suggestOrderEndtime = '';
    },
    // 模糊搜索方法
    filterOption(input, option) {
      const text = option.componentOptions.children[0].text.toLowerCase();
      this.searchQuery = input;
      return text.includes(input.toLowerCase());
    },

    // 处理搜索输入
    handleSearch(val) {
      this.searchQuery = val;
      console.log(val);
      if (!val) {
        this.filteredAdvertiserList = [...this.advertiserList];
        return;
      }
      const query = val.toLowerCase();
      this.filteredAdvertiserList = this.advertiserList.filter(
        (item) =>
          item.advertiser_name.toLowerCase().includes(query) ||
          String(item.advertiser_id).toLowerCase().includes(query)
      );
      console.log(this.filteredAdvertiserList, this.selectedAdvertiser);
    },

    // 修改后的方法
    async selectAllFilteredAdvertisers() {
      console.log('this.searchQuery', this.searchQuery);
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        let filteredAdvertiserList = this.advertiserList.filter(
          (item) =>
            item.advertiser_name.toLowerCase().includes(query) ||
            String(item.advertiser_id).toLowerCase().includes(query)
        );
        this.selectedAdvertiser = filteredAdvertiserList.map(
          (item) => item.advertiser_id
        );
      } else {
        // 如果没有过滤结果，则全选原始列表
        this.selectedAdvertiser = this.advertiserList.map(
          (item) => item.advertiser_id
        );
      }
      this.searchQuery = '';
      // this.$nextTick(() => {
      //   if (this.$refs.advertiserSelect) {
      //     this.$refs.advertiserSelect.setInputValue('');
      //   }
      // });
      console.log(this.filteredAdvertiserList, this.selectedAdvertiser);
      if (this.suggestOrderDrawer) {
        this.getSuggestOrder();
      }
    },

    // 清空选择
    clearAllAdvertisers() {
      this.searchQuery = '';
      this.selectedAdvertiser = [];
      if (this.suggestOrderDrawer) {
        this.suggestOrderList = [];
        this.suggestOrderEndtime = '';
      }
    },

    handleAdversterChange(e) {
      console.log(e);
      this.selectedAdvertiser = e;
      if (this.suggestOrderDrawer) {
        this.getSuggestOrder();
      }
    },
    async getSuggestOrder() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QY_GET_SUGGEST_ORDER}`,
        method: 'POST',
        params: {
          advertiser_id: this.selectedAdvertiser.join(','),
          checktype: this.checktype,
        },
      });
      this.suggestOrderList = data.ad_list;
      this.suggestOrderEndtime = data.end_time;
    },
    selectAllAdvertisers() {
      if (this.advertiserList && this.advertiserList.length > 0) {
        this.selectedAdvertiser = this.advertiserList.map(
          (item) => item.advertiser_id
        );
      }
    },
    async editOne(e, edit_value, edittype) {
      this.btnloadiong = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.EDIT_QY_AD_NEW}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id,
          ad_id: e.ad_info.id,
          edittype: edittype,
          edit_value: edit_value,
          old_value: edittype == '2'?e.ad_info.budget:e.ad_info.roi2_goal,
        },
      });
      this.btnloadiong = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      
      // 直接更新页面数据，不再调用接口刷新
      const adId = e.ad_info.id;
      const advertiserId = e.advertiser_id;
      
      // 更新对应数据数组中的值
      const updateItem = (item) => {
        if (item && item.ad_info) {
          if (edittype == 2 || edittype == '2') {
            this.$set(item.ad_info, 'budget', edit_value);
          } else if (edittype == 3 || edittype == '3') {
            this.$set(item.ad_info, 'roi2_goal', edit_value);
          }
        }
      };
      
      if (this.allOrderDrawer) {
        // 更新全部订单抽屉中的数据
        const item = this.alldata.find(
          (item) => item.ad_info && item.ad_info.id === adId && item.advertiser_id === advertiserId
        );
        updateItem(item);
      } else if (this.suggestOrderDrawer) {
        // 更新建议订单抽屉中的数据
        const item = this.suggestOrderList.find(
          (item) => item.ad_info && item.ad_info.id === adId && item.advertiser_id === advertiserId
        );
        updateItem(item);
      } else {
        // 更新主列表中的数据
        const item = this.data.find(
          (item) => item.ad_info && item.ad_info.id === adId && item.advertiser_id === advertiserId
        );
        updateItem(item);
      }
      
      // 关闭对应的 popover
      const popoverKey = `${adId}_${edittype}`;
      this.$set(this.popoverVisibleMap, popoverKey, false);
    },
    async set_commission_rate(
      advertiser_id,
      aweme_id,
      product_id,
      commission_rate
    ) {
      this.btnloadiong = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.EDIT_QY_PRODUCT_COMMISSION}`,
        method: 'POST',
        params: {
          advertiser_id: advertiser_id,
          aweme_id: aweme_id,
          product_id: product_id,
          commission_rate: commission_rate,
        },
      });
      this.btnloadiong = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      if (this.allOrderDrawer || this.suggestOrderDrawer) {
        this.searchResult();
      } else {
        this.data = [];
        this.getData();
      }
    },
    async set_divide_into_rate(
      advertiser_id,
      aweme_id,
      divide_into_rate
    ) {
      this.btnloadiong = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.EDIT_QY_AWEME_DIVIDE_INTO_RATE}`,
        method: 'POST',
        params: {
          advertiser_id: advertiser_id,
          aweme_id: aweme_id,
          divide_into_rate: divide_into_rate,
        },
      });
      this.btnloadiong = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      if (this.allOrderDrawer || this.suggestOrderDrawer) {
        this.searchResult();
      } else {
        this.data = [];
        this.getData();
      }
    },
    async setAdRemark(e) {
      console.log('备注', e);
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QY_ADD_AD_REMARK}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id,
          ad_id: e.ad_info.id,
          marketing_goal: this.marketing_goal,
          remark: this.remark,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      this.remark = '';
      if (this.allOrderDrawer || this.suggestOrderDrawer) {
        this.searchResult();
      } else {
        this.data = [];
        this.getData();
      }
    },
    //关闭预警规则弹窗
    closeRuleModal() {
      this.getData();
      this.showRuleModal = false;
    },
    closeScRuleModal() {
      this.getData();
      this.showScRuleModal = false;
    },
    setmonitor(e) {
      // this.$router.replace('/qy_monitor');
      this.ad_id = String(e.ad_info.id);
      this.showRuleModal = true;
    },
    setScmonitor(e) {
      this.$router.replace('/qy_materialMonitor');
      // this.ad_id = String(e.ad_info.id)
      // this.showScRuleModal = true
    },
    createBtn() {
      console.log(this.smart_bid_type);
      this.$message.success('暂未更新');
    },
    getStatusName(status) {
      const statusItem = this.statusData.find((item) => item.value === status);
      return statusItem ? statusItem.name : status;
    },
    getChecked(type) {
      let status = false;
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].key == type) {
          status = true;
        }
      }
      return status;
    },
    clearSelect() {
      this.selectedRowKeys = [];
      if (this.allOrderDrawer || this.suggestOrderDrawer) {
        // this.searchResult()
      } else {
        this.getData();
      }
    },
    changeDetailTopTab(e) {
      this.detailTab = e;
    },
    async releshAll() {
      this.releshBtn = true;
      this.getData();
      this.releshBtn = false;
    },
    changeTimerStatus() {
      this.timer_status = !this.timer_status;
      if (this.timer_status) {
        this.deadline = Date.now() + 1000 * 301;
      }
    },
    addwhite(e, type) {
      const that = this;
      Modal.confirm({
        title: '加白提醒',
        content:
          type == 'add'
            ? '是否确定加白该计划？加白后该计划后该计划将不会被监控。'
            : '是否确定取消加白该计划？取消加白后该计划后该计划将会重新被监控。',
        onOk: () => {
          that.addwhiteAction(e, type);
        },
      });
    },
    deleteAd(e) {
      const that = this;
      Modal.confirm({
        title: '删除提醒',
        content: '是否确定删除计划？',
        onOk: async () => {
          let opt_status = 'DELETE';
          const { code, msg, data } = await requestHttp({
            api: `${qcApi.STOP_QY_AD}`,
            method: 'POST',
            params: {
              advertiser_id: e.advertiser_id,
              ad_id: e.ad_info.id,
              opt_status: opt_status,
            },
          });
          if (code == 0) {
            that.$message.error(msg);
            return;
          }
          that.$message.success(msg);
          if (this.allOrderDrawer || this.suggestOrderDrawer) {
            that.searchResult();
          } else {
            that.getData();
          }
        },
      });
    },
    async addwhiteAction(e, type) {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QY_ADD_AD_WHITE}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id,
          ad_id: e?.ad_info?.id,
          marketing_goal: this.marketing_goal,
          order_create_day: e?.ad_info?.create_time,
          type: type,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      if (this.allOrderDrawer || this.suggestOrderDrawer) {
        this.searchResult();
      } else {
        this.data = [];
        this.getData();
      }
    },
    async onSwitchChange(e) {
      this.switchloading = true;
      let opt_status = e.ad_info.opt_status == 'ENABLE' ? 'DISABLE' : 'ENABLE';
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.STOP_QY_AD}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id,
          ad_id: e.ad_info.id,
          opt_status: opt_status,
        },
      });
      this.switchloading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      e.ad_info.opt_status = opt_status;
    },
    setTimeDay(timeday) {
      this.timeday = timeday;
      let todayDate = moment().format('YYYY-MM-DD');
      if (timeday == 0) {
        this.range_date = [todayDate, todayDate];
      } else if (timeday == -1) {
        this.range_date = [
          moment().subtract(1, 'days').format('YYYY-MM-DD'),
          moment().subtract(1, 'days').format('YYYY-MM-DD'),
        ];
      } else if (timeday == -3) {
        this.range_date = [
          moment().subtract(3, 'days').format('YYYY-MM-DD'),
          todayDate,
        ];
      } else if (timeday == -7) {
        this.range_date = [
          moment().subtract(7, 'days').format('YYYY-MM-DD'),
          todayDate,
        ];
      } else if (timeday == 1) {
        this.range_date = [
          moment().startOf('month').format('YYYY-MM-DD'),
          todayDate,
        ];
      } else if (timeday == 2) {
        this.range_date = [
          moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
          moment()
            .subtract(1, 'months')
            .endOf('month')
            .format('YYYY-MM-DD')
            .split('T')[0],
        ];
      }
      this.getReport();
    },
    onTimeChange(e, date) {
      this.range_date = date;
      this.timeday = '';
      this.getReport();
    },
    onTimeCreateChange(e, date) {
      this.page = 1;
      this.range_create_date = date;
      this.getData();
    },
    text_copy(context) {
      navigator.clipboard
        .writeText(context)
        .then(() => {
          this.$message.success('复制成功');
        })
        .catch((err) => {
          this.$message.error('复制失败');
        });
    },
    onSearchKey(e) {
      this.order_id = e;
      this.page = 1;
      this.data = [];
      this.getData();
    },
    // 生成搜索条件的唯一标识
    getSearchCacheKey() {
      const searchParams = {
        all_order_id: this.all_order_id,
        all_order_type: this.all_order_type,
        selectedAdvertiser: [...this.selectedAdvertiser].sort().join(','),
        start_date: this.range_date[0] ? this.range_date[0] : '',
        end_date: this.range_date[1] ? this.range_date[1] : '',
        marketing_goal: this.marketing_goal,
        sortby: this.sortby,
        sort: this.sort,
        smart_bid_type: this.smart_bid_type,
        all_status: this.all_status,
      };
      return JSON.stringify(searchParams);
    },
    async onSearchAllKey(e) {
      this.all_order_id = e;
      if (this.all_order_id == '') {
        this.$message.error('请正确输入ID/名称');
        return;
      }
      if (this.selectedAdvertiser.length == 0) {
        this.$message.error('请选择广告账户');
        return;
      }
      // 清空已选择的数据
      this.selectedRowKeys = [];
      this.selectedRow = [];
      this.searchResult();
    },
    async batchCheck() {
      if (this.selectedAdvertiser.length == 0) {
        this.$message.error('请选择广告账户');
        return;
      }
      this.alldata = [];
      this.succ = 0;
      // 重置分页
      this.allTablePagination.current = 1;
      this.allTablePagination.total = 0;
      this.spinning_all = true;
      for (let i = 0; i < this.suggestOrderList.length; i++) {
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.GET_QY_AD_LIST}`,
          method: 'POST',
          params: {
            start_date: this.range_date[0] ? this.range_date[0] : '',
            end_date: this.range_date[1] ? this.range_date[1] : '',
            advertiser_id: this.suggestOrderList[i].advertiser_id,
            marketing_goal: this.marketing_goal,
            search_keyword: this.suggestOrderList[i].order_id,
            sortby: this.sortby,
            sort: this.sort,
            page: 1,
            pagesize: this.pagesize,
            smart_bid_type: this.smart_bid_type,
            search_keyword_type: 'AD',
            status: this.all_status,
            adlab_scene:'OVERALL_PROJECT'
          },
        });
        this.succ = i + 1;
        console.log('succ', this.succ);
        let oneAdversiter = this.advertiserList.find(
          (item) => item.advertiser_id == this.suggestOrderList[i].advertiser_id
        );
        if (code == 0) {
          this.alldata.push({
            advertiser_id: this.suggestOrderList[i].advertiser_id,
            order_id: this.suggestOrderList[i].order_id,
            advertiser_name: oneAdversiter.advertiser_name,
            error: msg,
            ad_info: { id: i },
            stats_info: {},
          });
          // this.$message.error('获取失败：'+msg);
        } else {
          if (data.ad_list.length > 0) {
            for (let i = 0; i < data.ad_list.length; i++) {
              // 确保数据有 stats_info 对象
              const item = data.ad_list[i];
              if (!item.stats_info) {
                item.stats_info = {};
              }
              if (!item.ad_info) {
                item.ad_info = {};
              }
              this.alldata.push(item);
            }
          } else {
            this.alldata.push({
              advertiser_id: this.suggestOrderList[i].advertiser_id,
              order_id: this.suggestOrderList[i].order_id,
              advertiser_name: oneAdversiter.advertiser_name,
              error: '无计划数据',
              ad_info: { id: i },
              stats_info: {},
            });
          }
        }
      }
      this.spinning_all = false;
      // 对搜索结果集进行排序
      this.alldata = this.sortAllData(this.alldata);
      this.createAllDataMap(this.alldata);
      // 更新分页总数
      this.allTablePagination.total = this.alldata.length;
      // 如果当前页超出范围，重置到第一页
      if (this.allTablePagination.current > 1 && this.paginatedAlldata.length === 0) {
        this.allTablePagination.current = 1;
      }
    },
    async searchResult() {
      this.alldata = [];
      this.succ = 0;
      // 重置分页
      this.allTablePagination.current = 1;
      this.allTablePagination.total = 0;
      this.spinning_all = true;

      // 生成搜索条件唯一标识
      const cacheKey = this.getSearchCacheKey();
      // 获取缓存数据
      let cacheData = this.searchCache.get(cacheKey);
      
      // 如果没有缓存，初始化缓存结构
      if (!cacheData) {
        cacheData = {
          successData: new Map(), // 存储成功返回的数据，key为advertiser_id，value为数据数组
          failedAdvertisers: new Map(), // 存储失败的广告账户ID和错误信息（不包括40100限流错误），key为advertiser_id，value为错误数据对象
          rateLimitAdvertisers: new Set(), // 存储40100限流错误的广告账户ID（需要重试）
        };
        this.searchCache.set(cacheKey, cacheData);
      }

      // 确定需要搜索的广告账户列表（只搜索失败的或未缓存的，40100限流错误需要重试）
      const advertisersToSearch = [];
      for (let i = 0; i < this.selectedAdvertiser.length; i++) {
        const advertiserId = this.selectedAdvertiser[i];
        // 如果缓存中有成功数据，直接使用缓存
        if (cacheData.successData.has(advertiserId)) {
          const cachedItems = cacheData.successData.get(advertiserId);
          for (let j = 0; j < cachedItems.length; j++) {
            this.alldata.push(cachedItems[j]);
          }
          this.succ = i + 1;
        } else if (cacheData.failedAdvertisers.has(advertiserId)) {
          // 如果已经标记为失败（非40100错误），跳过搜索，但需要添加缓存的错误信息
          const failedData = cacheData.failedAdvertisers.get(advertiserId);
          this.alldata.push(failedData);
          this.succ = i + 1;
        } else {
          // 如果没有成功数据，且不是已失败的（包括40100限流错误和未搜索过的），都需要搜索
          advertisersToSearch.push({ index: i, advertiserId });
        }
      }

      // 对需要搜索的广告账户进行请求
      for (let i = 0; i < advertisersToSearch.length; i++) {
        const { index, advertiserId } = advertisersToSearch[i];
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.GET_QY_AD_LIST}`,
          method: 'POST',
          params: {
            start_date: this.range_date[0] ? this.range_date[0] : '',
            end_date: this.range_date[1] ? this.range_date[1] : '',
            advertiser_id: advertiserId,
            marketing_goal: this.marketing_goal,
            search_keyword: this.all_order_id,
            sortby: this.sortby,
            sort: this.sort,
            page: 1,
            pagesize:20,
            smart_bid_type: this.smart_bid_type,
            search_keyword_type: this.all_order_type,
            status: this.all_status,
            adlab_scene:'OVERALL_PROJECT'
          },
        });
        
        // 更新进度（包括已使用缓存的）
        const processedCount = this.selectedAdvertiser.length - advertisersToSearch.length + i + 1;
        this.succ = processedCount;
        console.log('succ', this.succ);
        
        let oneAdversiter = this.advertiserList.find(
          (item) => item.advertiser_id == advertiserId
        );
        
        if (code == 0) {
          // 请求失败，检查是否是40100限流错误
          const isRateLimitError = data && data.code === 40100;
          
          this.alldata.push({
            advertiser_id: advertiserId,
            advertiser_name: oneAdversiter ? oneAdversiter.advertiser_name : '',
            error: msg,
            ad_info: { id: index },
            stats_info: {},
          });
          
          if (isRateLimitError) {
            // 40100限流错误，不标记为失败，下次搜索时还会重试
            cacheData.rateLimitAdvertisers.add(advertiserId);
            // 从失败列表中移除（如果之前失败过）
            cacheData.failedAdvertisers.delete(advertiserId);
          } else {
            // 其他错误，标记为失败并缓存错误信息，下次不再搜索
            const failedData = {
              advertiser_id: advertiserId,
              advertiser_name: oneAdversiter ? oneAdversiter.advertiser_name : '',
              error: msg,
              ad_info: { id: index },
              stats_info: {},
            };
            cacheData.failedAdvertisers.set(advertiserId, failedData);
            // 从限流列表中移除（如果之前是限流错误）
            cacheData.rateLimitAdvertisers.delete(advertiserId);
          }
          // 如果之前有成功数据，清除它
          cacheData.successData.delete(advertiserId);
        } else {
          if (data && data.ad_list && data.ad_list.length > 0) {
            // 请求成功且有数据
            const successItems = [];
            for (let j = 0; j < data.ad_list.length; j++) {
              // 确保数据有 stats_info 对象
              const item = data.ad_list[j];
              if (!item.stats_info) {
                item.stats_info = {};
              }
              if (!item.ad_info) {
                item.ad_info = {};
              }
              this.alldata.push(item);
              successItems.push(item);
            }
            // 缓存成功的数据
            cacheData.successData.set(advertiserId, successItems);
            // 从失败列表和限流列表中移除（如果之前失败过或限流过）
            cacheData.failedAdvertisers.delete(advertiserId);
            cacheData.rateLimitAdvertisers.delete(advertiserId);
          } else {
            // 请求成功但无数据
            const noDataItem = {
              advertiser_id: advertiserId,
              advertiser_name: oneAdversiter ? oneAdversiter.advertiser_name : '',
              error: '无计划数据',
              ad_info: { id: index },
              stats_info: {},
            };
            this.alldata.push(noDataItem);
            // 记录失败的广告账户（无数据也算失败）并缓存错误信息
            cacheData.failedAdvertisers.set(advertiserId, noDataItem);
            // 从限流列表中移除（如果之前是限流错误）
            cacheData.rateLimitAdvertisers.delete(advertiserId);
            // 如果之前有成功数据，清除它
            cacheData.successData.delete(advertiserId);
          }
        }
      }
      
      this.spinning_all = false;
      // 对搜索结果集进行排序
      this.alldata = this.sortAllData(this.alldata);
      this.createAllDataMap(this.alldata);
      // 更新分页总数
      this.allTablePagination.total = this.alldata.length;
      // 如果当前页超出范围，重置到第一页
      if (this.allTablePagination.current > 1 && this.paginatedAlldata.length === 0) {
        this.allTablePagination.current = 1;
      }
    },
    // 处理独立表格分页变化
    handleAllTableChange(pagination, filters, sorter) {
      this.allTablePagination = {
        ...this.allTablePagination,
        current: pagination.current,
        pageSize: pagination.pageSize,
      };
    },
    onFinish() {
      if (!this.timer_status) {
        return;
      }
      this.$message.loading({ content: '刷新中...', key });
      this.deadtitle = '定时刷新中：正在刷新...';
      this.getReport();
      setTimeout(() => {
        this.$message.success({ content: '刷新成功!', key, duration: 2 });
        this.deadtitle = '定时刷新中：倒计时';
        this.deadline = Date.now() + 1000 * 301;
      }, 1000);
    },
    getDetail(e) {
      this.ad = e;
      this.post_advertiser_id = e.advertiser_id;
      this.$refs.detail.getAdDetail(e);
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRow = selectedRows;
      this.selectedRowKeys = selectedRowKeys;
    },

    // handleTableChange(e, filters, sorter) {
    //   this.pagination = e;
    //   if (sorter.order) {
    //     this.sort = sorter.order
    //     this.sortby = sorter.field
    //   } else {
    //     this.sort = 'descend'
    //     this.sortby = 'create_time'
    //   }
    //   this.page = e.current;
    //   this.pagesize = e.pageSize;
    //   this.getData();
    // },
    handleTableChange(e, filters, sorter) {
      console.log('点击了', sorter);

      // 检查排序条件是否发生变化
      const sortChanged =
        sorter.order &&
        (this.sort !== sorter.order || this.sortby !== sorter.columnKey);

      // 设置排序参数
      if (sorter.order) {
        this.sort = sorter.order;
        this.sortby = sorter.columnKey;
      } else {
        this.sort = 'descend';
        this.sortby = 'create_time';
      }

      // 只有在排序条件改变时才重置页码
      if (sortChanged) {
        this.page = 1;
        this.pagination = {
          ...e,
          current: 1,
        };
      } else {
        // 正常分页逻辑
        this.page = e.current;
        this.pagination = e;
      }

      this.pagesize = e.pageSize;
      this.getData();
    },
    handleChange(e) {
      this.status = e;
      this.page = 1;
      this.getData();
    },
    changeTypeAction(e) {
      this.search_keyword_type = e;
    },
    changeAllTypeAction(e) {
      this.all_order_type = e;
    },
    handleCostChange(e) {
      this.having_cost = e;
      this.page = 1;
      this.getData();
    },
    handletargetChange(e) {
      this.smart_bid_type = e.target.value;
      this.page = 1;
      this.getData();
    },
    async getData() {
      this.spinning = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_AD_LIST}`,
        method: 'POST',
        params: {
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
          advertiser_id: this.advertiser_id,
          status: this.status,
          marketing_goal: this.marketing_goal,
          search_keyword: this.order_id,
          sortby: this.sortby,
          sort: this.sort,
          page: this.page,
          pagesize: this.pagesize,
          smart_bid_type: this.smart_bid_type,
          having_cost: this.having_cost,
          create_start_date: this.range_create_date[0]
            ? this.range_create_date[0]
            : '',
          create_end_date: this.range_create_date[1]
            ? this.range_create_date[1]
            : '',
          search_keyword_type: this.search_keyword_type,
          adlab_scene:'OVERALL_PROJECT'
        },
      });
      this.spinning = false;
      if (code == 0) {
        // this.$message.error(msg)
        return;
      }
      if (!data) return;
      this.data = data.ad_list;
      this.pagination.total = data.page_info.total_num;
      this.createDataMap(data.ad_list);
    },
    createDataMap(list) {
      if (!list || list.length == 0) return;
      list.forEach((item) => {
        // 更新已存在的数据，确保 dataMap 中的数据是最新的
        this.dataMap[item.ad_info.id] = item;
      });
      console.log('this.dataMap', this.dataMap);
    },
    // 对搜索结果集进行排序
    sortAllData(data) {
      if (!data || data.length === 0) return data;
      
      // 分离有错误的数据、缺少必要字段的数据和正常数据
      const errorData = [];
      const normalData = [];
      
      data.forEach((item) => {
        // 如果有错误信息，或者缺少 ad_info，或者缺少 stats_info（当排序字段在 stats_info 中时）
        if (item.error || !item.ad_info) {
          errorData.push(item);
        } else if (this.sortby !== 'ad_id' && this.sortby !== 'create_time' && !item.stats_info) {
          // 如果排序字段在 stats_info 中，但 stats_info 不存在，也当作错误数据处理
          errorData.push(item);
        } else {
          normalData.push(item);
        }
      });
      
      // 对正常数据进行排序
      normalData.sort((a, b) => {
        let aValue, bValue;
        
        // 根据 sortby 字段获取值
        if (this.sortby === 'ad_id' || this.sortby === 'create_time') {
          // ad_info 中的字段
          aValue = a.ad_info && a.ad_info[this.sortby];
          bValue = b.ad_info && b.ad_info[this.sortby];
        } else {
          // stats_info 中的字段
          aValue = a.stats_info && a.stats_info[this.sortby];
          bValue = b.stats_info && b.stats_info[this.sortby];
        }
        
        // 处理空值
        if (aValue === null || aValue === undefined || aValue === '') {
          aValue = this.sortby === 'create_time' ? '' : 0;
        }
        if (bValue === null || bValue === undefined || bValue === '') {
          bValue = this.sortby === 'create_time' ? '' : 0;
        }
        
        // 时间字段使用字符串比较
        if (this.sortby === 'create_time') {
          const timeA = aValue || '';
          const timeB = bValue || '';
          if (this.sort === 'ascend') {
            return timeA.localeCompare(timeB);
          } else {
            return timeB.localeCompare(timeA);
          }
        }
        
        // 数字字段转换为数字进行比较
        const numA = parseFloat(aValue) || 0;
        const numB = parseFloat(bValue) || 0;
        
        // 根据排序方向进行比较
        if (this.sort === 'ascend') {
          return numA - numB;
        } else {
          return numB - numA;
        }
      });
      
      // 合并排序后的正常数据和错误数据
      return [...normalData, ...errorData];
    },
    createAllDataMap(list) {
      if (!list || list.length == 0) return;
      list.forEach((item) => {
        // 更新已存在的数据，确保 dataAllMap 中的数据是最新的
        this.dataAllMap[item.ad_info.id] = item;
      });
      console.log('this.dataAllMap', this.dataAllMap);
    },
    async getReport() {
      this.toploading = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_ADVERTISER_REPORT}`,
        method: 'POST',
        params: {
          source: 'SXT',
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
        },
      });
      this.toploading = false;
      if (code == 0) {
        return;
      }
      if (!data) return;
      this.report = data;
      this.getData();
    },
    goDetail(id) {
      window.open(
        'https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?id=' +
          id +
          '&origin_type=open_platform&pick_source=v.eCa95u'
      );
    },

    // 重试获取单条记录数据
    async retryGetAd(record, all_order_id = '', all_order_type = '') {
      try {
        // 显示加载状态
        this.$set(record, 'loading', true);

        // 确定搜索关键词和类型
        let searchKeyword = all_order_id ? all_order_id : this.all_order_id;
        let searchKeywordType = all_order_type
          ? all_order_type
          : this.all_order_type;

        // 如果是审核建议计划，使用order_id作为搜索关键词
        if (this.suggestOrderDrawer && record.order_id) {
          searchKeyword = record.order_id;
        }

        const { code, msg, data } = await requestHttp({
          api: `${qcApi.GET_QY_AD_LIST}`,
          method: 'POST',
          params: {
            start_date: this.range_date[0] ? this.range_date[0] : '',
            end_date: this.range_date[1] ? this.range_date[1] : '',
            advertiser_id: record.advertiser_id,
            marketing_goal: this.marketing_goal,
            search_keyword: searchKeyword,
            sortby: this.sortby,
            sort: this.sort,
            page: 1,
            pagesize: this.pagesize,
            smart_bid_type: this.smart_bid_type,
            search_keyword_type: searchKeywordType,
            status: this.all_status,
            adlab_scene:'OVERALL_PROJECT'
          },
        });

        // 隐藏加载状态
        this.$set(record, 'loading', false);

        if (code == 0) {
          // 更新错误信息
          this.$set(record, 'error', msg);
          this.$message.error('重试失败：' + msg);
          return;
        }

        if (data && data.ad_list && data.ad_list.length > 0) {
          // 更新记录数据
          const newData = data.ad_list[0];
          Object.assign(record, newData);

          // 清除错误信息
          this.$set(record, 'error', null);

          this.$message.success('重试成功');

          // 更新数据映射
          if (this.allOrderDrawer || this.suggestOrderDrawer) {
            this.createAllDataMap([record]);
          } else {
            this.createDataMap([record]);
          }
        } else {
          // 设置无数据错误
          this.$set(record, 'error', '无计划数据');
          this.$message.error('未找到相关数据');
        }
      } catch (error) {
        this.$set(record, 'loading', false);
        this.$set(record, 'error', '网络错误，请重试');
        this.$message.error('重试失败：' + error.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.extra-wrapper {
  position: absolute;
  right: 0px;
}

.ant-card-head-wrapper {
  text-align: left !important;
  font-weight: bold !important;
  color: #000;
}

.widget-1 {
  display: flex;

  .ant-statistic-content {
    font-family: open sans, Helvetica, Arial, sans-serif;
    font-weight: 700;
    color: inherit;
    font-size: 30px;
    line-height: 30px;
    text-align: center;
    margin: 10px auto;
  }

  .icon {
    width: 48px;
    height: 48px;
    position: absolute;
    right: 16px;
    margin: auto;
    background-color: #1890ff;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.12);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.ant-tabs-tab {
  font-weight: bold !important;
}

.extra-item {
  display: inline-block;
  margin-right: 24px;

  a {
    margin-left: 24px;
    color: #666;
    font-weight: bold;
  }

  .selected {
    color: #1890ff;
  }
}

.searchResult {
  .name {
    color: #333;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
  }
}

.aweme {
  display: flex;
}

.aweme-right {
  text-align: left;

  .aweme-title {
    color: #323335;
    font-weight: bold;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // width: 180px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    height: 45px;
  }
}

.small {
  font-size: 11px;
  line-height: 18px;
}

.tips {
  margin-bottom: 10px;
}

.showTemplate {
  .dataOverview {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 0;
  }

  .dataViewItem {
    flex: 1;
    margin-right: 0.5%;
    margin-left: 0.5%;
    border-radius: 15px;
    float: left;
    box-shadow: 0 2px 8px #00000026;
    margin-bottom: 10px;
    overflow: hidden;
    height: 120px;

    div {
      text-align: left;
      color: #333;
      font-size: 18px;
      padding-top: 20px;
      padding-left: 20px;
    }

    p {
      font-size: 24px;
      padding-top: 5px;
      font-weight: bold;
    }
  }
}

.copy-icon {
  height: 100px;
  border-radius: 5px;
  cursor: pointer;
}

.rowOperate {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 30px;

  .actionItem {
    margin-left: 10px;
    color: #597ef7;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}

.filterCondition {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  span {
    margin-left: 20px;
  }
}

.tags-container {
  padding: 16px 0px;
  overflow: hidden;
}

.tags-container .ad-tag {
  float: left;
  margin-left: 16px;
}

.tags-container .ad-tag:first-child {
  margin-left: 0;
}

.tags-container .inbl {
  display: inline-block;
  vertical-align: middle;
}

.tags-container .roi-input {
  position: relative;
  top: 1px;
}

.tags-container .roi-target-box {
  display: inline-block;
  margin-left: 24px;
}

.tags-container .info-item {
  float: left;
  height: 26px;
  position: relative;
}

.avatar {
  widows: 26px;
  height: 26px;
  border-radius: 50%;
  margin-right: 5px;
}

.tags-container .info-item.editable {
  padding-right: 28px;
}

.tags-container .info-item .content {
  display: inline-block;
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-container .info-item .content .nobid-bid-content {
  color: #999;
}

.tag {
  background: #f2f2f2;
  border-radius: 4px;
  color: #999;
  font-size: 14px;
  line-height: 22px;
  padding: 2px 8px;
}

.tag.red {
  background: #fff1ef;
  color: #e5453f;
}

.tag.gray {
  background: #f2f2f2;
  color: #999;
}

.tag.green {
  background: #e6f8ee;
  color: #34ba7b;
}

.copynum {
  font-weight: bold;
  color: red;
}

.product-item {
  display: flex;
  height: 56px;
  margin-top: 8px;
}

.product-item .good {
  padding-left: 0;
}

.product-item .icon {
  border-radius: 4px;
  height: 56px;
  width: 56px;
}

.product-item .info {
  padding-top: 3px;
}

.product-item .info .name {
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  margin: 0 0 8px 16px;
}

.product-item .info .id,
.product-item .info .price {
  color: #999;
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  padding: 0 16px;
}

.product-item .info .separator {
  border-right: 1px solid #999;
  display: inline-block;
  height: 8px;
  position: relative;
}

.product-item .info .price-num {
  color: #333;
  margin-left: 8px;
}

.ad-drawer__aweme-info {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 16px;
}

.title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  line-height: 34px;
}

.board-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 21px;
  min-width: 932px;

  .overview-board {
    background: #f2f2f2;
    background-color: #f2f2f2;
    margin: 0 10px 10px 0;
    border-radius: 8px;
    cursor: pointer;
    height: 108px;
    width: 175px;

    .inner {
      border-radius: 4px;
      padding: 12px 12px 17px;

      .metric {
        color: #252729;
        font-size: 14px;
        font-weight: 600;
        height: 20px;
        line-height: 20px;
        margin: 0;
      }

      .value {
        font-size: 20px;
        margin-top: 8px;
        font-weight: bold;
        color: rgb(51, 51, 51);
      }
    }
  }
}

.setting-item {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  min-height: 44px;
  padding: 12px 16px;
  width: 50%;
  float: left;

  label {
    color: #333;
    flex-shrink: 0;
    font-weight: bold;
    margin-right: 24px;
    width: 80px;
  }

  .display-value {
    color: #333;
    flex: 1 1;
  }
}

.footer {
  position: fixed;
  bottom: 0px;
  background: #fff;
  height: 80px;
  width: 940px;
  line-height: 80px;
  border-top: 1px solid #eee;

  button {
    margin-right: 10px;
  }
}

.videoimg {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
}

.dialog-left {
  width: 180px;
  float: left;
  padding-top: 20px;
  height: 100%;
  border-right: 1px solid #e5e5e5;
}

.dialog-left ul li {
  margin: 0 auto;
  line-height: 40px;
  font-size: 16px;
  color: #2d3035;
  width: 130px;
  height: 40px;
  border-radius: 3px;
  margin-bottom: 10px;
  text-align: left;
  cursor: pointer;
}

.dialog-center {
  width: 620px;
  float: left;
  padding: 10px 20px;
  color: #242a37;

  ul {
    padding: 0;
    margin: 0;
  }
}

.dialog-right {
  width: 190px;
  float: left;
  padding: 10px;
  color: #939cc0;
  height: 340px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
  scrollbar-width: thin;
  border-left: 1px solid #e5e5e5;
}

.dialog-center-title {
  font-size: 16px;
  margin-bottom: 10px;
}

li {
  list-style: none;
}

.dialog-right ul li {
  margin: 0 auto;
  line-height: 30px;
  font-size: 14px;
  color: #13151a;
  width: 184;
  height: 30px;
  border-radius: 3px;
  margin-bottom: 10px;
  text-align: left;
  padding-left: 10px;
  cursor: pointer;
  background: #f2f2f2;
  position: relative;
}

.dialog-right ul li span {
  float: right;
  margin-right: 10px;
}

.dialog-center ul li {
  width: 25%;
  margin-bottom: 10px;
  float: left;
}

.dialog-right ul {
  margin: 0;
  padding: 0;
}

.yAxis {
  display: flex;
  align-items: center;
  justify-content: center;

  input {
    width: 145px;
    border-radius: 5px;
  }

  & > div {
    display: flex;
    align-items: center;
  }

  section {
    width: 13px;
    height: 12px;
    background: #ff4d4f;
    border-radius: 3px;
    margin-right: 10px;
  }

  & > div:nth-child(1) {
    margin-right: 35px;

    section {
      background-color: #1890ff;
    }
  }
}

.yAxis + .totops {
  height: 0;
  opacity: 0;
}

/* 在你的CSS文件或<style>标签中添加以下样式 */
/deep/ .ant-table-tbody > tr > td {
  padding: 8px;
}

/deep/ .ant-table-thead > tr > th {
  padding: 8px;
}

.sticky-header-table /deep/ .ant-table-thead > tr > th {
  position: sticky;
  top: 0; /* 如果有顶部固定导航，可改成对应高度，如 64px */
  z-index: 3;
  background: #fff;
}

// css

.ant-card {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03),
    0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  border-top: 1px solid #efefef;
}

.acss-14lc1cu {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.acss-1fpsglh {
  margin-top: 8px;
  padding-top: 9px;
  border-top: 1px solid rgba(5, 5, 5, 0.06);
}

.acss-grxbm {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
}

.acss-eji7bv {
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}

.acss-1x0bxe0 {
  font-size: 14px;
  line-height: 22px;
}

.acss-72p16p {
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.88);
}

.acss-qdes8r {
  position: relative;
  top: 4px;
  float: left;
  margin-right: 20px;
}

.acss-1odwksc {
  float: left;
}

.acss-1qoci3j {
  height: 22px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 22px;
}

.acss-18kfphl {
  position: absolute;
  top: 4px;
  right: 0;
  line-height: 1;
  cursor: pointer;
}

.acss-f1zikh {
  height: 38px;
  margin-top: 4px;
  margin-bottom: 0;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.88);
  font-size: 30px;
  line-height: 38px;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
}

.acss-16mkun2 {
  margin-top: 10px;
}

.totalItem {
  text-align: left;

  b {
    margin-right: 30px;
  }
}

/deep/ .ant-checkbox + span {
  padding-left: 2px;
}
.product_img_box {
  display: flex;
}
.product_img {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  margin-right: 5px;
  cursor: pointer;
}
.remark {
  color: red;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  width: 200px;
  display: block;
  cursor: pointer;
  display: -webkit-box; /* 使用旧版 Flexbox 布局 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  -webkit-line-clamp: 2; /* 限制显示 2 行 */
}
/deep/ .ant-checkbox + span {
  padding-left: 2px;
}

//end
.aweme-id {
  // background: #e6f7ff;
  padding-left: 5px;
  padding-top: 2px;
  border-radius: 3px;
  padding-right: 5px;
  margin-top: 5px;
  cursor: pointer;
  display: flex;
  text-align: left;
  // &:hover {
  //   background: #fff;
  // }
  .aweme-id-left {
    display: flex;
    width: 40px;
    padding-left: 10px;
    img {
      width: 30px;
      height: 30px;
      border-radius: 3px;
      margin-top: 2px;
    }
  }
  .aweme-id-right {
    h6 {
      font-size: 12px;
      margin: 0px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 180px;
      padding-left: 5px;
    }
    p {
      font-size: 12px;
      margin: 0px;
      padding-left: 5px;
    }
  }
}

.statistic-wrapper {
  background: #e6f7ff;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  border-radius: 0px 3px 3px 0px;
}
.statistic-wrapper .statistic-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.statistic-wrapper .statistic-item .label {
  font-size: 12px;
  color: #999;
}
.statistic-wrapper .statistic-item .value {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
}
.statistic-wrapper .statistic-item .value.profit {
  color: #f00000;
  font-weight: bold;
}
.statistic-wrapper .statistic-item .value.loss {
  color: #00a511;
  font-weight: bold;
}
</style>
